var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _g, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _g2, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 135,
    viewBox: "0 0 161 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 122.839H147.167V122.94H160.5V122.839Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.723 123.934H109.224V124.034H112.723V123.934Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.764 119.103H139.039V119.203H146.764V119.103Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8873 119.779H0.5V119.88H17.8873V119.779Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0219 119.779H21.4736V119.88H24.0219V119.779Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.021 121.478H32.3076V121.578H70.021V121.478Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.12 14.2029C136.12 12.351 134.618 10.8494 132.766 10.8494C132.432 10.8494 132.11 10.9018 131.804 10.9903C131.852 10.6522 131.881 10.31 131.881 9.95974C131.881 6.03865 128.7 2.86232 124.783 2.86232C124.336 2.86232 123.902 2.9066 123.475 2.98309C122.384 1.19565 120.423 0 118.177 0C114.779 0 112.021 2.72947 111.969 6.11916C111.933 6.11916 111.901 6.11514 111.864 6.11514C108.704 6.11514 106.144 8.67552 106.144 11.8357C106.144 14.996 108.704 17.5564 111.864 17.5564H132.863C134.67 17.5 136.12 16.0225 136.12 14.2029Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2909 40.0565C25.2909 39.3319 24.7031 38.7441 23.9785 38.7441C23.8456 38.7441 23.7208 38.7643 23.6001 38.8005C23.6202 38.6676 23.6283 38.5348 23.6283 38.3979C23.6283 36.8641 22.3843 35.6201 20.8505 35.6201C20.6774 35.6201 20.5043 35.6362 20.3392 35.6684C19.9125 34.972 19.1435 34.501 18.2659 34.501C16.9374 34.501 15.8585 35.5678 15.8384 36.8923C15.8263 36.8923 15.8102 36.8923 15.7981 36.8923C14.5622 36.8923 13.5598 37.8947 13.5598 39.1306C13.5598 40.3665 14.5622 41.3689 15.7981 41.3689H24.0107C24.7192 41.3488 25.2869 40.7691 25.2869 40.0565H25.2909Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.945 27.4354C111.945 26.7108 111.357 26.123 110.632 26.123C110.5 26.123 110.375 26.1432 110.254 26.1794C110.274 26.0465 110.282 25.9137 110.282 25.7768C110.282 24.243 109.038 22.999 107.504 22.999C107.331 22.999 107.158 23.0151 106.993 23.0474C106.566 22.3509 105.798 21.8799 104.92 21.8799C103.591 21.8799 102.512 22.9467 102.492 24.2712C102.48 24.2712 102.464 24.2712 102.452 24.2712C101.216 24.2712 100.214 25.2736 100.214 26.5095C100.214 27.7454 101.216 28.7478 102.452 28.7478H110.665C111.373 28.7277 111.941 28.148 111.941 27.4354H111.945Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 56.9404H107.332V58.0878H108.479V56.9404Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 58.8604H107.332V60.0077H108.479V58.8604Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 66.5498H107.332V67.6972H108.479V66.5498Z",
    fill: "#FAFAFA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 68.4697H107.332V69.6171H108.479V68.4697Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 70.3945H107.332V71.5419H108.479V70.3945Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 76.1592H107.332V77.3065H108.479V76.1592Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 78.0791H107.332V79.2264H108.479V78.0791Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 64.6299H105.512V65.7772H106.659V64.6299Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 66.5498H105.512V67.6972H106.659V66.5498Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 68.4697H105.512V69.6171H106.659V68.4697Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 70.3945H105.512V71.5419H106.659V70.3945Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 72.3145H105.512V73.4618H106.659V72.3145Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 76.1592H105.512V77.3065H106.659V76.1592Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.659 78.0791H105.512V79.2264H106.659V78.0791Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 56.9404H103.689V58.0878H104.836V56.9404Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 58.8604H103.689V60.0077H104.836V58.8604Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 60.7852H103.689V61.9325H104.836V60.7852Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 62.7051H103.689V63.8524H104.836V62.7051Z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 64.6299H103.689V65.7772H104.836V64.6299Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 66.5498H103.689V67.6972H104.836V66.5498Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 68.4697H103.689V69.6171H104.836V68.4697Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 70.3945H103.689V71.5419H104.836V70.3945Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 72.3145H103.689V73.4618H104.836V72.3145Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 74.2393H103.689V75.3866H104.836V74.2393Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 78.0791H103.689V79.2264H104.836V78.0791Z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 56.9404H101.869V58.0878H103.016V56.9404Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 58.8604H101.869V60.0077H103.016V58.8604Z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 60.7852H101.869V61.9325H103.016V60.7852Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 62.7051H101.869V63.8524H103.016V62.7051Z",
    fill: "#FAFAFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 64.6299H101.869V65.7772H103.016V64.6299Z",
    fill: "#FAFAFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 66.5498H101.869V67.6972H103.016V66.5498Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 68.4697H101.869V69.6171H103.016V68.4697Z",
    fill: "#FAFAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M103.016 85.7686H101.869V86.9159H103.016V85.7686Z",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 56.9404H100.049V58.0878H101.196V56.9404Z",
    fill: "#FAFAFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 58.8604H100.049V60.0077H101.196V58.8604Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 60.7852H100.049V61.9325H101.196V60.7852Z",
    fill: "#FAFAFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 62.7051H100.049V63.8524H101.196V62.7051Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 64.6299H100.049V65.7772H101.196V64.6299Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 66.5498H100.049V67.6972H101.196V66.5498Z",
    fill: "#FAFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 68.4697H100.049V69.6171H101.196V68.4697Z",
    fill: "#FAFAFA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 70.3945H100.049V71.5419H101.196V70.3945Z",
    fill: "#FAFAFA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 81.9238H100.049V83.0712H101.196V81.9238Z",
    fill: "#FAFAFA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 83.8486H100.049V84.996H101.196V83.8486Z",
    fill: "#FAFAFA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 85.7686H100.049V86.9159H101.196V85.7686Z",
    fill: "#FAFAFA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 87.6934H100.049V88.8407H101.196V87.6934Z",
    fill: "#FAFAFA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M101.196 95.3779H100.049V96.5253H101.196V95.3779Z",
    fill: "#FAFAFA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 56.9404H98.2302V58.0878H99.3775V56.9404Z",
    fill: "#FAFAFA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 58.8604H98.2302V60.0077H99.3775V58.8604Z",
    fill: "#FAFAFA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 60.7852H98.2302V61.9325H99.3775V60.7852Z",
    fill: "#FAFAFA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 62.7051H98.2302V63.8524H99.3775V62.7051Z",
    fill: "#FAFAFA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 64.6299H98.2302V65.7772H99.3775V64.6299Z",
    fill: "#FAFAFA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 66.5498H98.2302V67.6972H99.3775V66.5498Z",
    fill: "#FAFAFA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 68.4697H98.2302V69.6171H99.3775V68.4697Z",
    fill: "#FAFAFA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 70.3945H98.2302V71.5419H99.3775V70.3945Z",
    fill: "#FAFAFA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 72.3145H98.2302V73.4618H99.3775V72.3145Z",
    fill: "#FAFAFA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 74.2393H98.2302V75.3866H99.3775V74.2393Z",
    fill: "#FAFAFA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 80.0039H98.2302V81.1513H99.3775V80.0039Z",
    fill: "#FAFAFA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 81.9238H98.2302V83.0712H99.3775V81.9238Z",
    fill: "#FAFAFA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 83.8486H98.2302V84.996H99.3775V83.8486Z",
    fill: "#FAFAFA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 85.7686H98.2302V86.9159H99.3775V85.7686Z",
    fill: "#FAFAFA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 87.6934H98.2302V88.8407H99.3775V87.6934Z",
    fill: "#FAFAFA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3775 95.3779H98.2302V96.5253H99.3775V95.3779Z",
    fill: "#FAFAFA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 56.9404H96.4058V58.0878H97.5532V56.9404Z",
    fill: "#FAFAFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 58.8604H96.4058V60.0077H97.5532V58.8604Z",
    fill: "#FAFAFA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 60.7852H96.4058V61.9325H97.5532V60.7852Z",
    fill: "#FAFAFA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 62.7051H96.4058V63.8524H97.5532V62.7051Z",
    fill: "#FAFAFA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 64.6299H96.4058V65.7772H97.5532V64.6299Z",
    fill: "#FAFAFA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 66.5498H96.4058V67.6972H97.5532V66.5498Z",
    fill: "#FAFAFA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 68.4697H96.4058V69.6171H97.5532V68.4697Z",
    fill: "#FAFAFA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 70.3945H96.4058V71.5419H97.5532V70.3945Z",
    fill: "#FAFAFA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 72.3145H96.4058V73.4618H97.5532V72.3145Z",
    fill: "#FAFAFA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 74.2393H96.4058V75.3866H97.5532V74.2393Z",
    fill: "#FAFAFA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 76.1592H96.4058V77.3065H97.5532V76.1592Z",
    fill: "#FAFAFA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 78.0791H96.4058V79.2264H97.5532V78.0791Z",
    fill: "#FAFAFA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 80.0039H96.4058V81.1513H97.5532V80.0039Z",
    fill: "#FAFAFA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 81.9238H96.4058V83.0712H97.5532V81.9238Z",
    fill: "#FAFAFA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 83.8486H96.4058V84.996H97.5532V83.8486Z",
    fill: "#FAFAFA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 85.7686H96.4058V86.9159H97.5532V85.7686Z",
    fill: "#FAFAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 87.6934H96.4058V88.8407H97.5532V87.6934Z",
    fill: "#FAFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5532 89.6133H96.4058V90.7606H97.5532V89.6133Z",
    fill: "#FAFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 56.9404H94.5869V58.0878H95.7343V56.9404Z",
    fill: "#FAFAFA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 58.8604H94.5869V60.0077H95.7343V58.8604Z",
    fill: "#FAFAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 60.7852H94.5869V61.9325H95.7343V60.7852Z",
    fill: "#FAFAFA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 62.7051H94.5869V63.8524H95.7343V62.7051Z",
    fill: "#FAFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 64.6299H94.5869V65.7772H95.7343V64.6299Z",
    fill: "#FAFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 66.5498H94.5869V67.6972H95.7343V66.5498Z",
    fill: "#FAFAFA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 68.4697H94.5869V69.6171H95.7343V68.4697Z",
    fill: "#FAFAFA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 70.3945H94.5869V71.5419H95.7343V70.3945Z",
    fill: "#FAFAFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 72.3145H94.5869V73.4618H95.7343V72.3145Z",
    fill: "#FAFAFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 74.2393H94.5869V75.3866H95.7343V74.2393Z",
    fill: "#FAFAFA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 80.0039H94.5869V81.1513H95.7343V80.0039Z",
    fill: "#FAFAFA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 81.9238H94.5869V83.0712H95.7343V81.9238Z",
    fill: "#FAFAFA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 83.8486H94.5869V84.996H95.7343V83.8486Z",
    fill: "#FAFAFA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7343 85.7686H94.5869V86.9159H95.7343V85.7686Z",
    fill: "#FAFAFA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 56.9404H92.7667V58.0878H93.914V56.9404Z",
    fill: "#FAFAFA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 58.8604H92.7667V60.0077H93.914V58.8604Z",
    fill: "#FAFAFA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 60.7852H92.7667V61.9325H93.914V60.7852Z",
    fill: "#FAFAFA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 62.7051H92.7667V63.8524H93.914V62.7051Z",
    fill: "#FAFAFA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 64.6299H92.7667V65.7772H93.914V64.6299Z",
    fill: "#FAFAFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 66.5498H92.7667V67.6972H93.914V66.5498Z",
    fill: "#FAFAFA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 68.4697H92.7667V69.6171H93.914V68.4697Z",
    fill: "#FAFAFA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 70.3945H92.7667V71.5419H93.914V70.3945Z",
    fill: "#FAFAFA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 72.3145H92.7667V73.4618H93.914V72.3145Z",
    fill: "#FAFAFA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 74.2393H92.7667V75.3866H93.914V74.2393Z",
    fill: "#FAFAFA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 80.0039H92.7667V81.1513H93.914V80.0039Z",
    fill: "#FAFAFA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 81.9238H92.7667V83.0712H93.914V81.9238Z",
    fill: "#FAFAFA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M93.914 83.8486H92.7667V84.996H93.914V83.8486Z",
    fill: "#FAFAFA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 51.9482H72.2637V53.0956H73.4111V51.9482Z",
    fill: "#FAFAFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 53.873H72.2637V55.0204H73.4111V53.873Z",
    fill: "#FAFAFA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 55.793H72.2637V56.9403H73.4111V55.793Z",
    fill: "#FAFAFA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 57.7168H72.2637V58.8641H73.4111V57.7168Z",
    fill: "#FAFAFA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 59.6377H72.2637V60.785H73.4111V59.6377Z",
    fill: "#FAFAFA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 61.5576H72.2637V62.705H73.4111V61.5576Z",
    fill: "#FAFAFA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 63.4824H72.2637V64.6298H73.4111V63.4824Z",
    fill: "#FAFAFA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 65.4023H72.2637V66.5497H73.4111V65.4023Z",
    fill: "#FAFAFA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 71.167H72.2637V72.3143H73.4111V71.167Z",
    fill: "#FAFAFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4111 73.0918H72.2637V74.2391H73.4111V73.0918Z",
    fill: "#FAFAFA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 51.9482H70.4435V53.0956H71.5908V51.9482Z",
    fill: "#FAFAFA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 53.873H70.4435V55.0204H71.5908V53.873Z",
    fill: "#FAFAFA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 55.793H70.4435V56.9403H71.5908V55.793Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 57.7168H70.4435V58.8641H71.5908V57.7168Z",
    fill: "#FAFAFA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 59.6377H70.4435V60.785H71.5908V59.6377Z",
    fill: "#FAFAFA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 61.5576H70.4435V62.705H71.5908V61.5576Z",
    fill: "#FAFAFA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 63.4824H70.4435V64.6298H71.5908V63.4824Z",
    fill: "#FAFAFA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 65.4023H70.4435V66.5497H71.5908V65.4023Z",
    fill: "#FAFAFA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5908 73.0918H70.4435V74.2391H71.5908V73.0918Z",
    fill: "#FAFAFA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 51.9482H68.6239V53.0956H69.7713V51.9482Z",
    fill: "#FAFAFA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 53.873H68.6239V55.0204H69.7713V53.873Z",
    fill: "#FAFAFA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 55.793H68.6239V56.9403H69.7713V55.793Z",
    fill: "#FAFAFA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 57.7168H68.6239V58.8641H69.7713V57.7168Z",
    fill: "#FAFAFA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 59.6377H68.6239V60.785H69.7713V59.6377Z",
    fill: "#FAFAFA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 61.5576H68.6239V62.705H69.7713V61.5576Z",
    fill: "#FAFAFA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 63.4824H68.6239V64.6298H69.7713V63.4824Z",
    fill: "#FAFAFA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7713 65.4023H68.6239V66.5497H69.7713V65.4023Z",
    fill: "#FAFAFA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 51.9482H66.8003V53.0956H67.9476V51.9482Z",
    fill: "#FAFAFA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 53.873H66.8003V55.0204H67.9476V53.873Z",
    fill: "#FAFAFA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 55.793H66.8003V56.9403H67.9476V55.793Z",
    fill: "#FAFAFA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 57.7168H66.8003V58.8641H67.9476V57.7168Z",
    fill: "#FAFAFA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 59.6377H66.8003V60.785H67.9476V59.6377Z",
    fill: "#FAFAFA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 61.5576H66.8003V62.705H67.9476V61.5576Z",
    fill: "#FAFAFA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 65.4023H66.8003V66.5497H67.9476V65.4023Z",
    fill: "#FAFAFA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 67.3271H66.8003V68.4745H67.9476V67.3271Z",
    fill: "#FAFAFA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 73.0918H66.8003V74.2391H67.9476V73.0918Z",
    fill: "#FAFAFA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 75.0117H66.8003V76.1591H67.9476V75.0117Z",
    fill: "#FAFAFA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 76.9365H66.8003V78.0839H67.9476V76.9365Z",
    fill: "#FAFAFA"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 78.8564H66.8003V80.0038H67.9476V78.8564Z",
    fill: "#FAFAFA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 80.7803H66.8003V81.9276H67.9476V80.7803Z",
    fill: "#FAFAFA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 82.7012H66.8003V83.8485H67.9476V82.7012Z",
    fill: "#FAFAFA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9476 84.6211H66.8003V85.7684H67.9476V84.6211Z",
    fill: "#FAFAFA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 51.9482H64.9807V53.0956H66.1281V51.9482Z",
    fill: "#FAFAFA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 53.873H64.9807V55.0204H66.1281V53.873Z",
    fill: "#FAFAFA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 55.793H64.9807V56.9403H66.1281V55.793Z",
    fill: "#FAFAFA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 57.7168H64.9807V58.8641H66.1281V57.7168Z",
    fill: "#FAFAFA"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 59.6377H64.9807V60.785H66.1281V59.6377Z",
    fill: "#FAFAFA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 61.5576H64.9807V62.705H66.1281V61.5576Z",
    fill: "#FAFAFA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 67.3271H64.9807V68.4745H66.1281V67.3271Z",
    fill: "#FAFAFA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 69.2471H64.9807V70.3944H66.1281V69.2471Z",
    fill: "#FAFAFA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 71.167H64.9807V72.3143H66.1281V71.167Z",
    fill: "#FAFAFA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 73.0918H64.9807V74.2391H66.1281V73.0918Z",
    fill: "#FAFAFA"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 75.0117H64.9807V76.1591H66.1281V75.0117Z",
    fill: "#FAFAFA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 76.9365H64.9807V78.0839H66.1281V76.9365Z",
    fill: "#FAFAFA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 78.8564H64.9807V80.0038H66.1281V78.8564Z",
    fill: "#FAFAFA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 80.7803H64.9807V81.9276H66.1281V80.7803Z",
    fill: "#FAFAFA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 82.7012H64.9807V83.8485H66.1281V82.7012Z",
    fill: "#FAFAFA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 84.6211H64.9807V85.7684H66.1281V84.6211Z",
    fill: "#FAFAFA"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 86.5459H64.9807V87.6932H66.1281V86.5459Z",
    fill: "#FAFAFA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1281 90.3906H64.9807V91.538H66.1281V90.3906Z",
    fill: "#FAFAFA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 51.9482H63.1611V53.0956H64.3085V51.9482Z",
    fill: "#FAFAFA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 53.873H63.1611V55.0204H64.3085V53.873Z",
    fill: "#FAFAFA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 55.793H63.1611V56.9403H64.3085V55.793Z",
    fill: "#FAFAFA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 57.7168H63.1611V58.8641H64.3085V57.7168Z",
    fill: "#FAFAFA"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 59.6377H63.1611V60.785H64.3085V59.6377Z",
    fill: "#FAFAFA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 61.5576H63.1611V62.705H64.3085V61.5576Z",
    fill: "#FAFAFA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 67.3271H63.1611V68.4745H64.3085V67.3271Z",
    fill: "#FAFAFA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 69.2471H63.1611V70.3944H64.3085V69.2471Z",
    fill: "#FAFAFA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 71.167H63.1611V72.3143H64.3085V71.167Z",
    fill: "#FAFAFA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 73.0918H63.1611V74.2391H64.3085V73.0918Z",
    fill: "#FAFAFA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 78.8564H63.1611V80.0038H64.3085V78.8564Z",
    fill: "#FAFAFA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 80.7803H63.1611V81.9276H64.3085V80.7803Z",
    fill: "#FAFAFA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 82.7012H63.1611V83.8485H64.3085V82.7012Z",
    fill: "#FAFAFA"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 84.6211H63.1611V85.7684H64.3085V84.6211Z",
    fill: "#FAFAFA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 86.5459H63.1611V87.6932H64.3085V86.5459Z",
    fill: "#FAFAFA"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 90.3906H63.1611V91.538H64.3085V90.3906Z",
    fill: "#FAFAFA"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3085 92.3105H63.1611V93.4579H64.3085V92.3105Z",
    fill: "#FAFAFA"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 69.8184H46.6398V70.9657H47.7872V69.8184Z",
    fill: "#FAFAFA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 71.7432H46.6398V72.8905H47.7872V71.7432Z",
    fill: "#FAFAFA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 73.6631H46.6398V74.8104H47.7872V73.6631Z",
    fill: "#FAFAFA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 75.5879H46.6398V76.7352H47.7872V75.5879Z",
    fill: "#FAFAFA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 77.5078H46.6398V78.6552H47.7872V77.5078Z",
    fill: "#FAFAFA"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 79.4326H46.6398V80.58H47.7872V79.4326Z",
    fill: "#FAFAFA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 81.3525H46.6398V82.4999H47.7872V81.3525Z",
    fill: "#FAFAFA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 87.1172H46.6398V88.2645H47.7872V87.1172Z",
    fill: "#FAFAFA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 89.042H46.6398V90.1893H47.7872V89.042Z",
    fill: "#FAFAFA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7872 90.9619H46.6398V92.1093H47.7872V90.9619Z",
    fill: "#FAFAFA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 69.8184H44.8162V70.9657H45.9635V69.8184Z",
    fill: "#FAFAFA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 71.7432H44.8162V72.8905H45.9635V71.7432Z",
    fill: "#FAFAFA"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 73.6631H44.8162V74.8104H45.9635V73.6631Z",
    fill: "#FAFAFA"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 75.5879H44.8162V76.7352H45.9635V75.5879Z",
    fill: "#FAFAFA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 77.5078H44.8162V78.6552H45.9635V77.5078Z",
    fill: "#FAFAFA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 79.4326H44.8162V80.58H45.9635V79.4326Z",
    fill: "#FAFAFA"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9635 81.3525H44.8162V82.4999H45.9635V81.3525Z",
    fill: "#FAFAFA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 69.8184H42.9966V70.9657H44.1439V69.8184Z",
    fill: "#FAFAFA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 71.7432H42.9966V72.8905H44.1439V71.7432Z",
    fill: "#FAFAFA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 73.6631H42.9966V74.8104H44.1439V73.6631Z",
    fill: "#FAFAFA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 75.5879H42.9966V76.7352H44.1439V75.5879Z",
    fill: "#FAFAFA"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 77.5078H42.9966V78.6552H44.1439V77.5078Z",
    fill: "#FAFAFA"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 79.4326H42.9966V80.58H44.1439V79.4326Z",
    fill: "#FAFAFA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1439 81.3525H42.9966V82.4999H44.1439V81.3525Z",
    fill: "#FAFAFA"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 69.8184H41.1763V70.9657H42.3237V69.8184Z",
    fill: "#FAFAFA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 71.7432H41.1763V72.8905H42.3237V71.7432Z",
    fill: "#FAFAFA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 73.6631H41.1763V74.8104H42.3237V73.6631Z",
    fill: "#FAFAFA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 75.5879H41.1763V76.7352H42.3237V75.5879Z",
    fill: "#FAFAFA"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 77.5078H41.1763V78.6552H42.3237V77.5078Z",
    fill: "#FAFAFA"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 79.4326H41.1763V80.58H42.3237V79.4326Z",
    fill: "#FAFAFA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 81.3525H41.1763V82.4999H42.3237V81.3525Z",
    fill: "#FAFAFA"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 83.2725H41.1763V84.4198H42.3237V83.2725Z",
    fill: "#FAFAFA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 85.1973H41.1763V86.3446H42.3237V85.1973Z",
    fill: "#FAFAFA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 87.1172H41.1763V88.2645H42.3237V87.1172Z",
    fill: "#FAFAFA"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3237 89.042H41.1763V90.1893H42.3237V89.042Z",
    fill: "#FAFAFA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 69.8184H39.3568V70.9657H40.5042V69.8184Z",
    fill: "#FAFAFA"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 71.7432H39.3568V72.8905H40.5042V71.7432Z",
    fill: "#FAFAFA"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 73.6631H39.3568V74.8104H40.5042V73.6631Z",
    fill: "#FAFAFA"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 75.5879H39.3568V76.7352H40.5042V75.5879Z",
    fill: "#FAFAFA"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 77.5078H39.3568V78.6552H40.5042V77.5078Z",
    fill: "#FAFAFA"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 79.4326H39.3568V80.58H40.5042V79.4326Z",
    fill: "#FAFAFA"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 81.3525H39.3568V82.4999H40.5042V81.3525Z",
    fill: "#FAFAFA"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 83.2725H39.3568V84.4198H40.5042V83.2725Z",
    fill: "#FAFAFA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 85.1973H39.3568V86.3446H40.5042V85.1973Z",
    fill: "#FAFAFA"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 87.1172H39.3568V88.2645H40.5042V87.1172Z",
    fill: "#FAFAFA"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 89.042H39.3568V90.1893H40.5042V89.042Z",
    fill: "#FAFAFA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 90.9619H39.3568V92.1093H40.5042V90.9619Z",
    fill: "#FAFAFA"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 96.7266H39.3568V97.8739H40.5042V96.7266Z",
    fill: "#FAFAFA"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5042 98.6514H39.3568V99.7987H40.5042V98.6514Z",
    fill: "#FAFAFA"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 69.8184H37.5331V70.9657H38.6805V69.8184Z",
    fill: "#FAFAFA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 71.7432H37.5331V72.8905H38.6805V71.7432Z",
    fill: "#FAFAFA"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 73.6631H37.5331V74.8104H38.6805V73.6631Z",
    fill: "#FAFAFA"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 79.4326H37.5331V80.58H38.6805V79.4326Z",
    fill: "#FAFAFA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 81.3525H37.5331V82.4999H38.6805V81.3525Z",
    fill: "#FAFAFA"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 83.2725H37.5331V84.4198H38.6805V83.2725Z",
    fill: "#FAFAFA"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 85.1973H37.5331V86.3446H38.6805V85.1973Z",
    fill: "#FAFAFA"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 87.1172H37.5331V88.2645H38.6805V87.1172Z",
    fill: "#FAFAFA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 89.042H37.5331V90.1893H38.6805V89.042Z",
    fill: "#FAFAFA"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 90.9619H37.5331V92.1093H38.6805V90.9619Z",
    fill: "#FAFAFA"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 96.7266H37.5331V97.8739H38.6805V96.7266Z",
    fill: "#FAFAFA"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 98.6514H37.5331V99.7987H38.6805V98.6514Z",
    fill: "#FAFAFA"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6805 100.571H37.5331V101.719H38.6805V100.571Z",
    fill: "#FAFAFA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 58.2891H18.451V59.4364H19.5983V58.2891Z",
    fill: "#FAFAFA"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 60.209H18.451V61.3563H19.5983V60.209Z",
    fill: "#FAFAFA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 62.1338H18.451V63.2811H19.5983V62.1338Z",
    fill: "#FAFAFA"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 64.0537H18.451V65.2011H19.5983V64.0537Z",
    fill: "#FAFAFA"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 65.9785H18.451V67.1259H19.5983V65.9785Z",
    fill: "#FAFAFA"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 67.8984H18.451V69.0458H19.5983V67.8984Z",
    fill: "#FAFAFA"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 69.8184H18.451V70.9657H19.5983V69.8184Z",
    fill: "#FAFAFA"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 71.7432H18.451V72.8905H19.5983V71.7432Z",
    fill: "#FAFAFA"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 73.6631H18.451V74.8104H19.5983V73.6631Z",
    fill: "#FAFAFA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 75.5879H18.451V76.7352H19.5983V75.5879Z",
    fill: "#FAFAFA"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 77.5078H18.451V78.6552H19.5983V77.5078Z",
    fill: "#FAFAFA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 79.4326H18.451V80.58H19.5983V79.4326Z",
    fill: "#FAFAFA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 81.3525H18.451V82.4999H19.5983V81.3525Z",
    fill: "#FAFAFA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 83.2725H18.451V84.4198H19.5983V83.2725Z",
    fill: "#FAFAFA"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 85.1973H18.451V86.3446H19.5983V85.1973Z",
    fill: "#FAFAFA"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 87.1172H18.451V88.2645H19.5983V87.1172Z",
    fill: "#FAFAFA"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 89.042H18.451V90.1893H19.5983V89.042Z",
    fill: "#FAFAFA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 90.9619H18.451V92.1093H19.5983V90.9619Z",
    fill: "#FAFAFA"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 92.8818H18.451V94.0292H19.5983V92.8818Z",
    fill: "#FAFAFA"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 94.8066H18.451V95.954H19.5983V94.8066Z",
    fill: "#FAFAFA"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 96.7266H18.451V97.8739H19.5983V96.7266Z",
    fill: "#FAFAFA"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 98.6514H18.451V99.7987H19.5983V98.6514Z",
    fill: "#FAFAFA"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5983 100.571H18.451V101.719H19.5983V100.571Z",
    fill: "#FAFAFA"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 58.2891H16.6274V59.4364H17.7747V58.2891Z",
    fill: "#FAFAFA"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 60.209H16.6274V61.3563H17.7747V60.209Z",
    fill: "#FAFAFA"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 62.1338H16.6274V63.2811H17.7747V62.1338Z",
    fill: "#FAFAFA"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 64.0537H16.6274V65.2011H17.7747V64.0537Z",
    fill: "#FAFAFA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 65.9785H16.6274V67.1259H17.7747V65.9785Z",
    fill: "#FAFAFA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 67.8984H16.6274V69.0458H17.7747V67.8984Z",
    fill: "#FAFAFA"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 69.8184H16.6274V70.9657H17.7747V69.8184Z",
    fill: "#FAFAFA"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 71.7432H16.6274V72.8905H17.7747V71.7432Z",
    fill: "#FAFAFA"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 73.6631H16.6274V74.8104H17.7747V73.6631Z",
    fill: "#FAFAFA"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 75.5879H16.6274V76.7352H17.7747V75.5879Z",
    fill: "#FAFAFA"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 77.5078H16.6274V78.6552H17.7747V77.5078Z",
    fill: "#FAFAFA"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 79.4326H16.6274V80.58H17.7747V79.4326Z",
    fill: "#FAFAFA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 81.3525H16.6274V82.4999H17.7747V81.3525Z",
    fill: "#FAFAFA"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 83.2725H16.6274V84.4198H17.7747V83.2725Z",
    fill: "#FAFAFA"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 85.1973H16.6274V86.3446H17.7747V85.1973Z",
    fill: "#FAFAFA"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 87.1172H16.6274V88.2645H17.7747V87.1172Z",
    fill: "#FAFAFA"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 89.042H16.6274V90.1893H17.7747V89.042Z",
    fill: "#FAFAFA"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 90.9619H16.6274V92.1093H17.7747V90.9619Z",
    fill: "#FAFAFA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 92.8818H16.6274V94.0292H17.7747V92.8818Z",
    fill: "#FAFAFA"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 58.2891H14.8077V59.4364H15.9551V58.2891Z",
    fill: "#FAFAFA"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 60.209H14.8077V61.3563H15.9551V60.209Z",
    fill: "#FAFAFA"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 62.1338H14.8077V63.2811H15.9551V62.1338Z",
    fill: "#FAFAFA"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 64.0537H14.8077V65.2011H15.9551V64.0537Z",
    fill: "#FAFAFA"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 65.9785H14.8077V67.1259H15.9551V65.9785Z",
    fill: "#FAFAFA"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 67.8984H14.8077V69.0458H15.9551V67.8984Z",
    fill: "#FAFAFA"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 69.8184H14.8077V70.9657H15.9551V69.8184Z",
    fill: "#FAFAFA"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 71.7432H14.8077V72.8905H15.9551V71.7432Z",
    fill: "#FAFAFA"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 73.6631H14.8077V74.8104H15.9551V73.6631Z",
    fill: "#FAFAFA"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 75.5879H14.8077V76.7352H15.9551V75.5879Z",
    fill: "#FAFAFA"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 77.5078H14.8077V78.6552H15.9551V77.5078Z",
    fill: "#FAFAFA"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 79.4326H14.8077V80.58H15.9551V79.4326Z",
    fill: "#FAFAFA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 81.3525H14.8077V82.4999H15.9551V81.3525Z",
    fill: "#FAFAFA"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 83.2725H14.8077V84.4198H15.9551V83.2725Z",
    fill: "#FAFAFA"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 85.1973H14.8077V86.3446H15.9551V85.1973Z",
    fill: "#FAFAFA"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 87.1172H14.8077V88.2645H15.9551V87.1172Z",
    fill: "#FAFAFA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 89.042H14.8077V90.1893H15.9551V89.042Z",
    fill: "#FAFAFA"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 90.9619H14.8077V92.1093H15.9551V90.9619Z",
    fill: "#FAFAFA"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9551 92.8818H14.8077V94.0292H15.9551V92.8818Z",
    fill: "#FAFAFA"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 58.2891H12.9882V59.4364H14.1356V58.2891Z",
    fill: "#FAFAFA"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 60.209H12.9882V61.3563H14.1356V60.209Z",
    fill: "#FAFAFA"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 62.1338H12.9882V63.2811H14.1356V62.1338Z",
    fill: "#FAFAFA"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 64.0537H12.9882V65.2011H14.1356V64.0537Z",
    fill: "#FAFAFA"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 65.9785H12.9882V67.1259H14.1356V65.9785Z",
    fill: "#FAFAFA"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 67.8984H12.9882V69.0458H14.1356V67.8984Z",
    fill: "#FAFAFA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 69.8184H12.9882V70.9657H14.1356V69.8184Z",
    fill: "#FAFAFA"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 71.7432H12.9882V72.8905H14.1356V71.7432Z",
    fill: "#FAFAFA"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 73.6631H12.9882V74.8104H14.1356V73.6631Z",
    fill: "#FAFAFA"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 75.5879H12.9882V76.7352H14.1356V75.5879Z",
    fill: "#FAFAFA"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 77.5078H12.9882V78.6552H14.1356V77.5078Z",
    fill: "#FAFAFA"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 79.4326H12.9882V80.58H14.1356V79.4326Z",
    fill: "#FAFAFA"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 81.3525H12.9882V82.4999H14.1356V81.3525Z",
    fill: "#FAFAFA"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 83.2725H12.9882V84.4198H14.1356V83.2725Z",
    fill: "#FAFAFA"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1356 85.1973H12.9882V86.3446H14.1356V85.1973Z",
    fill: "#FAFAFA"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 58.2891H11.1639V59.4364H12.3112V58.2891Z",
    fill: "#FAFAFA"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 60.209H11.1639V61.3563H12.3112V60.209Z",
    fill: "#FAFAFA"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 62.1338H11.1639V63.2811H12.3112V62.1338Z",
    fill: "#FAFAFA"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 64.0537H11.1639V65.2011H12.3112V64.0537Z",
    fill: "#FAFAFA"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 65.9785H11.1639V67.1259H12.3112V65.9785Z",
    fill: "#FAFAFA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 67.8984H11.1639V69.0458H12.3112V67.8984Z",
    fill: "#FAFAFA"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 69.8184H11.1639V70.9657H12.3112V69.8184Z",
    fill: "#FAFAFA"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 71.7432H11.1639V72.8905H12.3112V71.7432Z",
    fill: "#FAFAFA"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 73.6631H11.1639V74.8104H12.3112V73.6631Z",
    fill: "#FAFAFA"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 75.5879H11.1639V76.7352H12.3112V75.5879Z",
    fill: "#FAFAFA"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 77.5078H11.1639V78.6552H12.3112V77.5078Z",
    fill: "#FAFAFA"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 79.4326H11.1639V80.58H12.3112V79.4326Z",
    fill: "#FAFAFA"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3112 81.3525H11.1639V82.4999H12.3112V81.3525Z",
    fill: "#FAFAFA"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 58.2891H9.34503V59.4364H10.4924V58.2891Z",
    fill: "#FAFAFA"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 60.209H9.34503V61.3563H10.4924V60.209Z",
    fill: "#FAFAFA"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 62.1338H9.34503V63.2811H10.4924V62.1338Z",
    fill: "#FAFAFA"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 64.0537H9.34503V65.2011H10.4924V64.0537Z",
    fill: "#FAFAFA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 65.9785H9.34503V67.1259H10.4924V65.9785Z",
    fill: "#FAFAFA"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 67.8984H9.34503V69.0458H10.4924V67.8984Z",
    fill: "#FAFAFA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 69.8184H9.34503V70.9657H10.4924V69.8184Z",
    fill: "#FAFAFA"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 71.7432H9.34503V72.8905H10.4924V71.7432Z",
    fill: "#FAFAFA"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 73.6631H9.34503V74.8104H10.4924V73.6631Z",
    fill: "#FAFAFA"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 75.5879H9.34503V76.7352H10.4924V75.5879Z",
    fill: "#FAFAFA"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 77.5078H9.34503V78.6552H10.4924V77.5078Z",
    fill: "#FAFAFA"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4924 79.4326H9.34503V80.58H10.4924V79.4326Z",
    fill: "#FAFAFA"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 72.3145H143.141V73.4618H144.288V72.3145Z",
    fill: "#FAFAFA"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 74.2393H143.141V75.3866H144.288V74.2393Z",
    fill: "#FAFAFA"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 76.1592H143.141V77.3065H144.288V76.1592Z",
    fill: "#FAFAFA"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 78.0791H143.141V79.2264H144.288V78.0791Z",
    fill: "#FAFAFA"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 80.0039H143.141V81.1513H144.288V80.0039Z",
    fill: "#FAFAFA"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 81.9238H143.141V83.0712H144.288V81.9238Z",
    fill: "#FAFAFA"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 83.8486H143.141V84.996H144.288V83.8486Z",
    fill: "#FAFAFA"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 85.7686H143.141V86.9159H144.288V85.7686Z",
    fill: "#FAFAFA"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 87.6934H143.141V88.8407H144.288V87.6934Z",
    fill: "#FAFAFA"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 89.6133H143.141V90.7606H144.288V89.6133Z",
    fill: "#FAFAFA"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 91.5342H143.141V92.6815H144.288V91.5342Z",
    fill: "#FAFAFA"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 93.458H143.141V94.6054H144.288V93.458Z",
    fill: "#FAFAFA"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 95.3779H143.141V96.5253H144.288V95.3779Z",
    fill: "#FAFAFA"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 97.3027H143.141V98.4501H144.288V97.3027Z",
    fill: "#FAFAFA"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 99.2227H143.141V100.37H144.288V99.2227Z",
    fill: "#FAFAFA"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 101.144H143.141V102.291H144.288V101.144Z",
    fill: "#FAFAFA"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 103.067H143.141V104.215H144.288V103.067Z",
    fill: "#FAFAFA"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 104.987H143.141V106.135H144.288V104.987Z",
    fill: "#FAFAFA"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 106.912H143.141V108.059H144.288V106.912Z",
    fill: "#FAFAFA"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M144.288 108.832H143.141V109.979H144.288V108.832Z",
    fill: "#FAFAFA"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 72.3145H141.321V73.4618H142.469V72.3145Z",
    fill: "#FAFAFA"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 74.2393H141.321V75.3866H142.469V74.2393Z",
    fill: "#FAFAFA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 76.1592H141.321V77.3065H142.469V76.1592Z",
    fill: "#FAFAFA"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 78.0791H141.321V79.2264H142.469V78.0791Z",
    fill: "#FAFAFA"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 80.0039H141.321V81.1513H142.469V80.0039Z",
    fill: "#FAFAFA"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 81.9238H141.321V83.0712H142.469V81.9238Z",
    fill: "#FAFAFA"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 83.8486H141.321V84.996H142.469V83.8486Z",
    fill: "#FAFAFA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 85.7686H141.321V86.9159H142.469V85.7686Z",
    fill: "#FAFAFA"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 87.6934H141.321V88.8407H142.469V87.6934Z",
    fill: "#FAFAFA"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 89.6133H141.321V90.7606H142.469V89.6133Z",
    fill: "#FAFAFA"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 91.5342H141.321V92.6815H142.469V91.5342Z",
    fill: "#FAFAFA"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 93.458H141.321V94.6054H142.469V93.458Z",
    fill: "#FAFAFA"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 95.3779H141.321V96.5253H142.469V95.3779Z",
    fill: "#FAFAFA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 97.3027H141.321V98.4501H142.469V97.3027Z",
    fill: "#FAFAFA"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 99.2227H141.321V100.37H142.469V99.2227Z",
    fill: "#FAFAFA"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 101.144H141.321V102.291H142.469V101.144Z",
    fill: "#FAFAFA"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 103.067H141.321V104.215H142.469V103.067Z",
    fill: "#FAFAFA"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M142.469 104.987H141.321V106.135H142.469V104.987Z",
    fill: "#FAFAFA"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 72.3145H139.498V73.4618H140.645V72.3145Z",
    fill: "#FAFAFA"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 74.2393H139.498V75.3866H140.645V74.2393Z",
    fill: "#FAFAFA"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 76.1592H139.498V77.3065H140.645V76.1592Z",
    fill: "#FAFAFA"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 78.0791H139.498V79.2264H140.645V78.0791Z",
    fill: "#FAFAFA"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 80.0039H139.498V81.1513H140.645V80.0039Z",
    fill: "#FAFAFA"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 81.9238H139.498V83.0712H140.645V81.9238Z",
    fill: "#FAFAFA"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 83.8486H139.498V84.996H140.645V83.8486Z",
    fill: "#FAFAFA"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 85.7686H139.498V86.9159H140.645V85.7686Z",
    fill: "#FAFAFA"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 87.6934H139.498V88.8407H140.645V87.6934Z",
    fill: "#FAFAFA"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 89.6133H139.498V90.7606H140.645V89.6133Z",
    fill: "#FAFAFA"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 91.5342H139.498V92.6815H140.645V91.5342Z",
    fill: "#FAFAFA"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 93.458H139.498V94.6054H140.645V93.458Z",
    fill: "#FAFAFA"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 95.3779H139.498V96.5253H140.645V95.3779Z",
    fill: "#FAFAFA"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 97.3027H139.498V98.4501H140.645V97.3027Z",
    fill: "#FAFAFA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 99.2227H139.498V100.37H140.645V99.2227Z",
    fill: "#FAFAFA"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 101.144H139.498V102.291H140.645V101.144Z",
    fill: "#FAFAFA"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 103.067H139.498V104.215H140.645V103.067Z",
    fill: "#FAFAFA"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M140.645 104.987H139.498V106.135H140.645V104.987Z",
    fill: "#FAFAFA"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 86.3447H149.953V87.4921H151.1V86.3447Z",
    fill: "#FAFAFA"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 88.2646H149.953V89.412H151.1V88.2646Z",
    fill: "#FAFAFA"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 90.1846H149.953V91.3319H151.1V90.1846Z",
    fill: "#FAFAFA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 92.1094H149.953V93.2567H151.1V92.1094Z",
    fill: "#FAFAFA"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 94.0293H149.953V95.1766H151.1V94.0293Z",
    fill: "#FAFAFA"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 95.9541H149.953V97.1014H151.1V95.9541Z",
    fill: "#FAFAFA"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 97.874H149.953V99.0214H151.1V97.874Z",
    fill: "#FAFAFA"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 99.7949H149.953V100.942H151.1V99.7949Z",
    fill: "#FAFAFA"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 101.719H149.953V102.866H151.1V101.719Z",
    fill: "#FAFAFA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 103.639H149.953V104.786H151.1V103.639Z",
    fill: "#FAFAFA"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 105.563H149.953V106.711H151.1V105.563Z",
    fill: "#FAFAFA"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 107.483H149.953V108.631H151.1V107.483Z",
    fill: "#FAFAFA"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 109.408H149.953V110.556H151.1V109.408Z",
    fill: "#FAFAFA"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 86.3447H148.133V87.4921H149.28V86.3447Z",
    fill: "#FAFAFA"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 88.2646H148.133V89.412H149.28V88.2646Z",
    fill: "#FAFAFA"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 90.1846H148.133V91.3319H149.28V90.1846Z",
    fill: "#FAFAFA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 92.1094H148.133V93.2567H149.28V92.1094Z",
    fill: "#FAFAFA"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 94.0293H148.133V95.1766H149.28V94.0293Z",
    fill: "#FAFAFA"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 95.9541H148.133V97.1014H149.28V95.9541Z",
    fill: "#FAFAFA"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 97.874H148.133V99.0214H149.28V97.874Z",
    fill: "#FAFAFA"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 99.7949H148.133V100.942H149.28V99.7949Z",
    fill: "#FAFAFA"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 101.719H148.133V102.866H149.28V101.719Z",
    fill: "#FAFAFA"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 103.639H148.133V104.786H149.28V103.639Z",
    fill: "#FAFAFA"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 105.563H148.133V106.711H149.28V105.563Z",
    fill: "#FAFAFA"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 107.483H148.133V108.631H149.28V107.483Z",
    fill: "#FAFAFA"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M149.28 109.408H148.133V110.556H149.28V109.408Z",
    fill: "#FAFAFA"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 86.3447H146.31V87.4921H147.457V86.3447Z",
    fill: "#FAFAFA"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 88.2646H146.31V89.412H147.457V88.2646Z",
    fill: "#FAFAFA"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 90.1846H146.31V91.3319H147.457V90.1846Z",
    fill: "#FAFAFA"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 92.1094H146.31V93.2567H147.457V92.1094Z",
    fill: "#FAFAFA"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 94.0293H146.31V95.1766H147.457V94.0293Z",
    fill: "#FAFAFA"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 95.9541H146.31V97.1014H147.457V95.9541Z",
    fill: "#FAFAFA"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 97.874H146.31V99.0214H147.457V97.874Z",
    fill: "#FAFAFA"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 99.7949H146.31V100.942H147.457V99.7949Z",
    fill: "#FAFAFA"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 101.719H146.31V102.866H147.457V101.719Z",
    fill: "#FAFAFA"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 103.639H146.31V104.786H147.457V103.639Z",
    fill: "#FAFAFA"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 105.563H146.31V106.711H147.457V105.563Z",
    fill: "#FAFAFA"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 107.483H146.31V108.631H147.457V107.483Z",
    fill: "#FAFAFA"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 109.408H146.31V110.556H147.457V109.408Z",
    fill: "#FAFAFA"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M147.457 111.328H146.31V112.475H147.457V111.328Z",
    fill: "#FAFAFA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 86.916H136.196V88.0634H137.344V86.916Z",
    fill: "#FAFAFA"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 88.8359H136.196V89.9833H137.344V88.8359Z",
    fill: "#FAFAFA"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 90.7607H136.196V91.9081H137.344V90.7607Z",
    fill: "#FAFAFA"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 92.6807H136.196V93.828H137.344V92.6807Z",
    fill: "#FAFAFA"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 94.6055H136.196V95.7528H137.344V94.6055Z",
    fill: "#FAFAFA"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 96.5254H136.196V97.6727H137.344V96.5254Z",
    fill: "#FAFAFA"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 98.4463H136.196V99.5936H137.344V98.4463Z",
    fill: "#FAFAFA"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 100.37H136.196V101.517H137.344V100.37Z",
    fill: "#FAFAFA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 102.291H136.196V103.438H137.344V102.291Z",
    fill: "#FAFAFA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 104.215H136.196V105.362H137.344V104.215Z",
    fill: "#FAFAFA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M137.344 109.979H136.196V111.127H137.344V109.979Z",
    fill: "#FAFAFA"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 86.916H134.373V88.0634H135.521V86.916Z",
    fill: "#FAFAFA"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 88.8359H134.373V89.9833H135.521V88.8359Z",
    fill: "#FAFAFA"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 90.7607H134.373V91.9081H135.521V90.7607Z",
    fill: "#FAFAFA"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 92.6807H134.373V93.828H135.521V92.6807Z",
    fill: "#FAFAFA"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 94.6055H134.373V95.7528H135.521V94.6055Z",
    fill: "#FAFAFA"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 96.5254H134.373V97.6727H135.521V96.5254Z",
    fill: "#FAFAFA"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 98.4463H134.373V99.5936H135.521V98.4463Z",
    fill: "#FAFAFA"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 100.37H134.373V101.517H135.521V100.37Z",
    fill: "#FAFAFA"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 102.291H134.373V103.438H135.521V102.291Z",
    fill: "#FAFAFA"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 108.056H134.373V109.203H135.521V108.056Z",
    fill: "#FAFAFA"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M135.521 109.979H134.373V111.127H135.521V109.979Z",
    fill: "#FAFAFA"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 86.916H132.553V88.0634H133.7V86.916Z",
    fill: "#FAFAFA"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 88.8359H132.553V89.9833H133.7V88.8359Z",
    fill: "#FAFAFA"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 90.7607H132.553V91.9081H133.7V90.7607Z",
    fill: "#FAFAFA"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 92.6807H132.553V93.828H133.7V92.6807Z",
    fill: "#FAFAFA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 94.6055H132.553V95.7528H133.7V94.6055Z",
    fill: "#FAFAFA"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 96.5254H132.553V97.6727H133.7V96.5254Z",
    fill: "#FAFAFA"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 98.4463H132.553V99.5936H133.7V98.4463Z",
    fill: "#FAFAFA"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 100.37H132.553V101.517H133.7V100.37Z",
    fill: "#FAFAFA"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 106.135H132.553V107.282H133.7V106.135Z",
    fill: "#FAFAFA"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 108.056H132.553V109.203H133.7V108.056Z",
    fill: "#FAFAFA"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7 109.979H132.553V111.127H133.7V109.979Z",
    fill: "#FAFAFA"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 57.7168H115.625V58.8641H116.772V57.7168Z",
    fill: "#FAFAFA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 59.6377H115.625V60.785H116.772V59.6377Z",
    fill: "#FAFAFA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 61.5576H115.625V62.705H116.772V61.5576Z",
    fill: "#FAFAFA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 63.4824H115.625V64.6298H116.772V63.4824Z",
    fill: "#FAFAFA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 65.4023H115.625V66.5497H116.772V65.4023Z",
    fill: "#FAFAFA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 67.3271H115.625V68.4745H116.772V67.3271Z",
    fill: "#FAFAFA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 69.2471H115.625V70.3944H116.772V69.2471Z",
    fill: "#FAFAFA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 71.167H115.625V72.3143H116.772V71.167Z",
    fill: "#FAFAFA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 73.0918H115.625V74.2391H116.772V73.0918Z",
    fill: "#FAFAFA"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 75.0117H115.625V76.1591H116.772V75.0117Z",
    fill: "#FAFAFA"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 76.9365H115.625V78.0839H116.772V76.9365Z",
    fill: "#FAFAFA"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 78.8564H115.625V80.0038H116.772V78.8564Z",
    fill: "#FAFAFA"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 80.7803H115.625V81.9276H116.772V80.7803Z",
    fill: "#FAFAFA"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 82.7012H115.625V83.8485H116.772V82.7012Z",
    fill: "#FAFAFA"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 84.6211H115.625V85.7684H116.772V84.6211Z",
    fill: "#FAFAFA"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 86.5459H115.625V87.6932H116.772V86.5459Z",
    fill: "#FAFAFA"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 88.4658H115.625V89.6132H116.772V88.4658Z",
    fill: "#FAFAFA"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 92.3105H115.625V93.4579H116.772V92.3105Z",
    fill: "#FAFAFA"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 94.2314H115.625V95.3788H116.772V94.2314Z",
    fill: "#FAFAFA"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 96.1553H115.625V97.3026H116.772V96.1553Z",
    fill: "#FAFAFA"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 98.0752H115.625V99.2225H116.772V98.0752Z",
    fill: "#FAFAFA"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M116.772 100H115.625V101.147H116.772V100Z",
    fill: "#FAFAFA"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 57.7168H113.806V58.8641H114.953V57.7168Z",
    fill: "#FAFAFA"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 59.6377H113.806V60.785H114.953V59.6377Z",
    fill: "#FAFAFA"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 61.5576H113.806V62.705H114.953V61.5576Z",
    fill: "#FAFAFA"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 63.4824H113.806V64.6298H114.953V63.4824Z",
    fill: "#FAFAFA"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 65.4023H113.806V66.5497H114.953V65.4023Z",
    fill: "#FAFAFA"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 67.3271H113.806V68.4745H114.953V67.3271Z",
    fill: "#FAFAFA"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 69.2471H113.806V70.3944H114.953V69.2471Z",
    fill: "#FAFAFA"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 71.167H113.806V72.3143H114.953V71.167Z",
    fill: "#FAFAFA"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 73.0918H113.806V74.2391H114.953V73.0918Z",
    fill: "#FAFAFA"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 75.0117H113.806V76.1591H114.953V75.0117Z",
    fill: "#FAFAFA"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 76.9365H113.806V78.0839H114.953V76.9365Z",
    fill: "#FAFAFA"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 78.8564H113.806V80.0038H114.953V78.8564Z",
    fill: "#FAFAFA"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 80.7803H113.806V81.9276H114.953V80.7803Z",
    fill: "#FAFAFA"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 82.7012H113.806V83.8485H114.953V82.7012Z",
    fill: "#FAFAFA"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 84.6211H113.806V85.7684H114.953V84.6211Z",
    fill: "#FAFAFA"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 86.5459H113.806V87.6932H114.953V86.5459Z",
    fill: "#FAFAFA"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 98.0752H113.806V99.2225H114.953V98.0752Z",
    fill: "#FAFAFA"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M114.953 100H113.806V101.147H114.953V100Z",
    fill: "#FAFAFA"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 57.7168H111.986V58.8641H113.133V57.7168Z",
    fill: "#FAFAFA"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 59.6377H111.986V60.785H113.133V59.6377Z",
    fill: "#FAFAFA"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 61.5576H111.986V62.705H113.133V61.5576Z",
    fill: "#FAFAFA"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 63.4824H111.986V64.6298H113.133V63.4824Z",
    fill: "#FAFAFA"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 65.4023H111.986V66.5497H113.133V65.4023Z",
    fill: "#FAFAFA"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 67.3271H111.986V68.4745H113.133V67.3271Z",
    fill: "#FAFAFA"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 69.2471H111.986V70.3944H113.133V69.2471Z",
    fill: "#FAFAFA"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 71.167H111.986V72.3143H113.133V71.167Z",
    fill: "#FAFAFA"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 73.0918H111.986V74.2391H113.133V73.0918Z",
    fill: "#FAFAFA"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 75.0117H111.986V76.1591H113.133V75.0117Z",
    fill: "#FAFAFA"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 76.9365H111.986V78.0839H113.133V76.9365Z",
    fill: "#FAFAFA"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 78.8564H111.986V80.0038H113.133V78.8564Z",
    fill: "#FAFAFA"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 80.7803H111.986V81.9276H113.133V80.7803Z",
    fill: "#FAFAFA"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 82.7012H111.986V83.8485H113.133V82.7012Z",
    fill: "#FAFAFA"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 84.6211H111.986V85.7684H113.133V84.6211Z",
    fill: "#FAFAFA"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 86.5459H111.986V87.6932H113.133V86.5459Z",
    fill: "#FAFAFA"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 90.3906H111.986V91.538H113.133V90.3906Z",
    fill: "#FAFAFA"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 92.3105H111.986V93.4579H113.133V92.3105Z",
    fill: "#FAFAFA"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 94.2314H111.986V95.3788H113.133V94.2314Z",
    fill: "#FAFAFA"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 96.1553H111.986V97.3026H113.133V96.1553Z",
    fill: "#FAFAFA"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 100H111.986V101.147H113.133V100Z",
    fill: "#FAFAFA"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 81.9238H122.235V83.0712H123.383V81.9238Z",
    fill: "#FAFAFA"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 83.8486H122.235V84.996H123.383V83.8486Z",
    fill: "#FAFAFA"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 85.7686H122.235V86.9159H123.383V85.7686Z",
    fill: "#FAFAFA"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 87.6934H122.235V88.8407H123.383V87.6934Z",
    fill: "#FAFAFA"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 89.6133H122.235V90.7606H123.383V89.6133Z",
    fill: "#FAFAFA"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 91.5342H122.235V92.6815H123.383V91.5342Z",
    fill: "#FAFAFA"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 93.458H122.235V94.6054H123.383V93.458Z",
    fill: "#FAFAFA"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 97.3027H122.235V98.4501H123.383V97.3027Z",
    fill: "#FAFAFA"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 99.2227H122.235V100.37H123.383V99.2227Z",
    fill: "#FAFAFA"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 101.144H122.235V102.291H123.383V101.144Z",
    fill: "#FAFAFA"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 103.067H122.235V104.215H123.383V103.067Z",
    fill: "#FAFAFA"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 104.987H122.235V106.135H123.383V104.987Z",
    fill: "#FAFAFA"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 106.912H122.235V108.059H123.383V106.912Z",
    fill: "#FAFAFA"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 108.832H122.235V109.979H123.383V108.832Z",
    fill: "#FAFAFA"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M123.383 110.757H122.235V111.904H123.383V110.757Z",
    fill: "#FAFAFA"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 81.9238H120.416V83.0712H121.563V81.9238Z",
    fill: "#FAFAFA"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 83.8486H120.416V84.996H121.563V83.8486Z",
    fill: "#FAFAFA"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 85.7686H120.416V86.9159H121.563V85.7686Z",
    fill: "#FAFAFA"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 87.6934H120.416V88.8407H121.563V87.6934Z",
    fill: "#FAFAFA"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 89.6133H120.416V90.7606H121.563V89.6133Z",
    fill: "#FAFAFA"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 91.5342H120.416V92.6815H121.563V91.5342Z",
    fill: "#FAFAFA"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 97.3027H120.416V98.4501H121.563V97.3027Z",
    fill: "#FAFAFA"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 99.2227H120.416V100.37H121.563V99.2227Z",
    fill: "#FAFAFA"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 101.144H120.416V102.291H121.563V101.144Z",
    fill: "#FAFAFA"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 103.067H120.416V104.215H121.563V103.067Z",
    fill: "#FAFAFA"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 104.987H120.416V106.135H121.563V104.987Z",
    fill: "#FAFAFA"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 106.912H120.416V108.059H121.563V106.912Z",
    fill: "#FAFAFA"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 108.832H120.416V109.979H121.563V108.832Z",
    fill: "#FAFAFA"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M121.563 110.757H120.416V111.904H121.563V110.757Z",
    fill: "#FAFAFA"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 81.9238H118.592V83.0712H119.739V81.9238Z",
    fill: "#FAFAFA"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 83.8486H118.592V84.996H119.739V83.8486Z",
    fill: "#FAFAFA"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 85.7686H118.592V86.9159H119.739V85.7686Z",
    fill: "#FAFAFA"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 87.6934H118.592V88.8407H119.739V87.6934Z",
    fill: "#FAFAFA"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 89.6133H118.592V90.7606H119.739V89.6133Z",
    fill: "#FAFAFA"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 91.5342H118.592V92.6815H119.739V91.5342Z",
    fill: "#FAFAFA"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 95.3779H118.592V96.5253H119.739V95.3779Z",
    fill: "#FAFAFA"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 97.3027H118.592V98.4501H119.739V97.3027Z",
    fill: "#FAFAFA"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 99.2227H118.592V100.37H119.739V99.2227Z",
    fill: "#FAFAFA"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 101.144H118.592V102.291H119.739V101.144Z",
    fill: "#FAFAFA"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 103.067H118.592V104.215H119.739V103.067Z",
    fill: "#FAFAFA"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 104.987H118.592V106.135H119.739V104.987Z",
    fill: "#FAFAFA"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 106.912H118.592V108.059H119.739V106.912Z",
    fill: "#FAFAFA"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 108.832H118.592V109.979H119.739V108.832Z",
    fill: "#FAFAFA"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M119.739 110.757H118.592V111.904H119.739V110.757Z",
    fill: "#FAFAFA"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 71.167H80.2223V72.3143H81.3696V71.167Z",
    fill: "#FAFAFA"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 73.0918H80.2223V74.2391H81.3696V73.0918Z",
    fill: "#FAFAFA"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 75.0117H80.2223V76.1591H81.3696V75.0117Z",
    fill: "#FAFAFA"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 76.9365H80.2223V78.0839H81.3696V76.9365Z",
    fill: "#FAFAFA"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 78.8564H80.2223V80.0038H81.3696V78.8564Z",
    fill: "#FAFAFA"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 80.7803H80.2223V81.9276H81.3696V80.7803Z",
    fill: "#FAFAFA"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 82.7012H80.2223V83.8485H81.3696V82.7012Z",
    fill: "#FAFAFA"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 84.6211H80.2223V85.7684H81.3696V84.6211Z",
    fill: "#FAFAFA"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 86.5459H80.2223V87.6932H81.3696V86.5459Z",
    fill: "#FAFAFA"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 88.4658H80.2223V89.6132H81.3696V88.4658Z",
    fill: "#FAFAFA"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 90.3906H80.2223V91.538H81.3696V90.3906Z",
    fill: "#FAFAFA"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 92.3105H80.2223V93.4579H81.3696V92.3105Z",
    fill: "#FAFAFA"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 94.2314H80.2223V95.3788H81.3696V94.2314Z",
    fill: "#FAFAFA"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 98.0752H80.2223V99.2225H81.3696V98.0752Z",
    fill: "#FAFAFA"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 100H80.2223V101.147H81.3696V100Z",
    fill: "#FAFAFA"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 101.92H80.2223V103.067H81.3696V101.92Z",
    fill: "#FAFAFA"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 103.845H80.2223V104.992H81.3696V103.845Z",
    fill: "#FAFAFA"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 107.685H80.2223V108.832H81.3696V107.685Z",
    fill: "#FAFAFA"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 109.609H80.2223V110.757H81.3696V109.609Z",
    fill: "#FAFAFA"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3696 111.529H80.2223V112.677H81.3696V111.529Z",
    fill: "#FAFAFA"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 71.167H78.4027V72.3143H79.5501V71.167Z",
    fill: "#FAFAFA"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 73.0918H78.4027V74.2391H79.5501V73.0918Z",
    fill: "#FAFAFA"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 75.0117H78.4027V76.1591H79.5501V75.0117Z",
    fill: "#FAFAFA"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 76.9365H78.4027V78.0839H79.5501V76.9365Z",
    fill: "#FAFAFA"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 78.8564H78.4027V80.0038H79.5501V78.8564Z",
    fill: "#FAFAFA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 80.7803H78.4027V81.9276H79.5501V80.7803Z",
    fill: "#FAFAFA"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 82.7012H78.4027V83.8485H79.5501V82.7012Z",
    fill: "#FAFAFA"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 84.6211H78.4027V85.7684H79.5501V84.6211Z",
    fill: "#FAFAFA"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 86.5459H78.4027V87.6932H79.5501V86.5459Z",
    fill: "#FAFAFA"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 88.4658H78.4027V89.6132H79.5501V88.4658Z",
    fill: "#FAFAFA"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 90.3906H78.4027V91.538H79.5501V90.3906Z",
    fill: "#FAFAFA"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 92.3105H78.4027V93.4579H79.5501V92.3105Z",
    fill: "#FAFAFA"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 94.2314H78.4027V95.3788H79.5501V94.2314Z",
    fill: "#FAFAFA"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 100H78.4027V101.147H79.5501V100Z",
    fill: "#FAFAFA"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 101.92H78.4027V103.067H79.5501V101.92Z",
    fill: "#FAFAFA"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 105.765H78.4027V106.912H79.5501V105.765Z",
    fill: "#FAFAFA"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 107.685H78.4027V108.832H79.5501V107.685Z",
    fill: "#FAFAFA"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 109.609H78.4027V110.757H79.5501V109.609Z",
    fill: "#FAFAFA"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5501 111.529H78.4027V112.677H79.5501V111.529Z",
    fill: "#FAFAFA"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 71.167H76.579V72.3143H77.7264V71.167Z",
    fill: "#FAFAFA"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 73.0918H76.579V74.2391H77.7264V73.0918Z",
    fill: "#FAFAFA"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 75.0117H76.579V76.1591H77.7264V75.0117Z",
    fill: "#FAFAFA"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 76.9365H76.579V78.0839H77.7264V76.9365Z",
    fill: "#FAFAFA"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 78.8564H76.579V80.0038H77.7264V78.8564Z",
    fill: "#FAFAFA"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 80.7803H76.579V81.9276H77.7264V80.7803Z",
    fill: "#FAFAFA"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 82.7012H76.579V83.8485H77.7264V82.7012Z",
    fill: "#FAFAFA"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 84.6211H76.579V85.7684H77.7264V84.6211Z",
    fill: "#FAFAFA"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 86.5459H76.579V87.6932H77.7264V86.5459Z",
    fill: "#FAFAFA"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 88.4658H76.579V89.6132H77.7264V88.4658Z",
    fill: "#FAFAFA"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 90.3906H76.579V91.538H77.7264V90.3906Z",
    fill: "#FAFAFA"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 92.3105H76.579V93.4579H77.7264V92.3105Z",
    fill: "#FAFAFA"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 94.2314H76.579V95.3788H77.7264V94.2314Z",
    fill: "#FAFAFA"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 96.1553H76.579V97.3026H77.7264V96.1553Z",
    fill: "#FAFAFA"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 100H76.579V101.147H77.7264V100Z",
    fill: "#FAFAFA"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 103.845H76.579V104.992H77.7264V103.845Z",
    fill: "#FAFAFA"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 105.765H76.579V106.912H77.7264V105.765Z",
    fill: "#FAFAFA"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 107.685H76.579V108.832H77.7264V107.685Z",
    fill: "#FAFAFA"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 109.609H76.579V110.757H77.7264V109.609Z",
    fill: "#FAFAFA"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7264 111.529H76.579V112.677H77.7264V111.529Z",
    fill: "#FAFAFA"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 82.1299H87.6416V83.2772H88.789V82.1299Z",
    fill: "#FAFAFA"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 84.0498H87.6416V85.1971H88.789V84.0498Z",
    fill: "#FAFAFA"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 85.9697H87.6416V87.1171H88.789V85.9697Z",
    fill: "#FAFAFA"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 87.8945H87.6416V89.0419H88.789V87.8945Z",
    fill: "#FAFAFA"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 89.8145H87.6416V90.9618H88.789V89.8145Z",
    fill: "#FAFAFA"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 91.7393H87.6416V92.8866H88.789V91.7393Z",
    fill: "#FAFAFA"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 97.5039H87.6416V98.6513H88.789V97.5039Z",
    fill: "#FAFAFA"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 99.4238H87.6416V100.571H88.789V99.4238Z",
    fill: "#FAFAFA"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 101.349H87.6416V102.496H88.789V101.349Z",
    fill: "#FAFAFA"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 103.269H87.6416V104.416H88.789V103.269Z",
    fill: "#FAFAFA"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 105.193H87.6416V106.341H88.789V105.193Z",
    fill: "#FAFAFA"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 107.113H87.6416V108.261H88.789V107.113Z",
    fill: "#FAFAFA"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M88.789 109.034H87.6416V110.182H88.789V109.034Z",
    fill: "#FAFAFA"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 82.1299H85.8187V83.2772H86.966V82.1299Z",
    fill: "#FAFAFA"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 84.0498H85.8187V85.1971H86.966V84.0498Z",
    fill: "#FAFAFA"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 85.9697H85.8187V87.1171H86.966V85.9697Z",
    fill: "#FAFAFA"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 87.8945H85.8187V89.0419H86.966V87.8945Z",
    fill: "#FAFAFA"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 89.8145H85.8187V90.9618H86.966V89.8145Z",
    fill: "#FAFAFA"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 91.7393H85.8187V92.8866H86.966V91.7393Z",
    fill: "#FAFAFA"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 97.5039H85.8187V98.6513H86.966V97.5039Z",
    fill: "#FAFAFA"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 99.4238H85.8187V100.571H86.966V99.4238Z",
    fill: "#FAFAFA"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 101.349H85.8187V102.496H86.966V101.349Z",
    fill: "#FAFAFA"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 103.269H85.8187V104.416H86.966V103.269Z",
    fill: "#FAFAFA"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 105.193H85.8187V106.341H86.966V105.193Z",
    fill: "#FAFAFA"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 107.113H85.8187V108.261H86.966V107.113Z",
    fill: "#FAFAFA"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M86.966 110.958H85.8187V112.105H86.966V110.958Z",
    fill: "#FAFAFA"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 73.6631H25.3278V74.8104H26.4752V73.6631Z",
    fill: "#FAFAFA"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 75.5879H25.3278V76.7352H26.4752V75.5879Z",
    fill: "#FAFAFA"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 77.5078H25.3278V78.6552H26.4752V77.5078Z",
    fill: "#FAFAFA"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 79.4326H25.3278V80.58H26.4752V79.4326Z",
    fill: "#FAFAFA"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 81.3525H25.3278V82.4999H26.4752V81.3525Z",
    fill: "#FAFAFA"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 83.2725H25.3278V84.4198H26.4752V83.2725Z",
    fill: "#FAFAFA"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 85.1973H25.3278V86.3446H26.4752V85.1973Z",
    fill: "#FAFAFA"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 87.1172H25.3278V88.2645H26.4752V87.1172Z",
    fill: "#FAFAFA"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 89.042H25.3278V90.1893H26.4752V89.042Z",
    fill: "#FAFAFA"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 90.9619H25.3278V92.1093H26.4752V90.9619Z",
    fill: "#FAFAFA"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 92.8818H25.3278V94.0292H26.4752V92.8818Z",
    fill: "#FAFAFA"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 96.7266H25.3278V97.8739H26.4752V96.7266Z",
    fill: "#FAFAFA"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 98.6514H25.3278V99.7987H26.4752V98.6514Z",
    fill: "#FAFAFA"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 100.571H25.3278V101.719H26.4752V100.571Z",
    fill: "#FAFAFA"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 102.492H25.3278V103.64H26.4752V102.492Z",
    fill: "#FAFAFA"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 104.416H25.3278V105.563H26.4752V104.416Z",
    fill: "#FAFAFA"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 106.337H25.3278V107.484H26.4752V106.337Z",
    fill: "#FAFAFA"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 108.261H25.3278V109.408H26.4752V108.261Z",
    fill: "#FAFAFA"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4752 110.181H25.3278V111.328H26.4752V110.181Z",
    fill: "#FAFAFA"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 73.6631H23.5076V74.8104H24.6549V73.6631Z",
    fill: "#FAFAFA"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 75.5879H23.5076V76.7352H24.6549V75.5879Z",
    fill: "#FAFAFA"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 77.5078H23.5076V78.6552H24.6549V77.5078Z",
    fill: "#FAFAFA"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 79.4326H23.5076V80.58H24.6549V79.4326Z",
    fill: "#FAFAFA"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 81.3525H23.5076V82.4999H24.6549V81.3525Z",
    fill: "#FAFAFA"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 83.2725H23.5076V84.4198H24.6549V83.2725Z",
    fill: "#FAFAFA"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 85.1973H23.5076V86.3446H24.6549V85.1973Z",
    fill: "#FAFAFA"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 87.1172H23.5076V88.2645H24.6549V87.1172Z",
    fill: "#FAFAFA"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 89.042H23.5076V90.1893H24.6549V89.042Z",
    fill: "#FAFAFA"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 90.9619H23.5076V92.1093H24.6549V90.9619Z",
    fill: "#FAFAFA"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 92.8818H23.5076V94.0292H24.6549V92.8818Z",
    fill: "#FAFAFA"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 94.8066H23.5076V95.954H24.6549V94.8066Z",
    fill: "#FAFAFA"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 96.7266H23.5076V97.8739H24.6549V96.7266Z",
    fill: "#FAFAFA"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 98.6514H23.5076V99.7987H24.6549V98.6514Z",
    fill: "#FAFAFA"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 100.571H23.5076V101.719H24.6549V100.571Z",
    fill: "#FAFAFA"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 102.492H23.5076V103.64H24.6549V102.492Z",
    fill: "#FAFAFA"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 104.416H23.5076V105.563H24.6549V104.416Z",
    fill: "#FAFAFA"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 106.337H23.5076V107.484H24.6549V106.337Z",
    fill: "#FAFAFA"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 108.261H23.5076V109.408H24.6549V108.261Z",
    fill: "#FAFAFA"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6549 110.181H23.5076V111.328H24.6549V110.181Z",
    fill: "#FAFAFA"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 81.1514H34.2969V82.2987H35.4442V81.1514Z",
    fill: "#FAFAFA"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 83.0713H34.2969V84.2186H35.4442V83.0713Z",
    fill: "#FAFAFA"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 84.9922H34.2969V86.1395H35.4442V84.9922Z",
    fill: "#FAFAFA"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 86.916H34.2969V88.0634H35.4442V86.916Z",
    fill: "#FAFAFA"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 88.8359H34.2969V89.9833H35.4442V88.8359Z",
    fill: "#FAFAFA"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 90.7607H34.2969V91.9081H35.4442V90.7607Z",
    fill: "#FAFAFA"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 92.6807H34.2969V93.828H35.4442V92.6807Z",
    fill: "#FAFAFA"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 94.6055H34.2969V95.7528H35.4442V94.6055Z",
    fill: "#FAFAFA"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 96.5254H34.2969V97.6727H35.4442V96.5254Z",
    fill: "#FAFAFA"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4442 98.4463H34.2969V99.5936H35.4442V98.4463Z",
    fill: "#FAFAFA"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 81.1514H32.4772V82.2987H33.6246V81.1514Z",
    fill: "#FAFAFA"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 83.0713H32.4772V84.2186H33.6246V83.0713Z",
    fill: "#FAFAFA"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 84.9922H32.4772V86.1395H33.6246V84.9922Z",
    fill: "#FAFAFA"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 86.916H32.4772V88.0634H33.6246V86.916Z",
    fill: "#FAFAFA"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 88.8359H32.4772V89.9833H33.6246V88.8359Z",
    fill: "#FAFAFA"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 90.7607H32.4772V91.9081H33.6246V90.7607Z",
    fill: "#FAFAFA"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 92.6807H32.4772V93.828H33.6246V92.6807Z",
    fill: "#FAFAFA"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 94.6055H32.4772V95.7528H33.6246V94.6055Z",
    fill: "#FAFAFA"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6246 96.5254H32.4772V97.6727H33.6246V96.5254Z",
    fill: "#FAFAFA"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1458 25.9103C45.1458 23.9497 43.5556 22.3595 41.595 22.3595C41.2408 22.3595 40.8986 22.4119 40.5765 22.5085C40.6288 22.1542 40.657 21.7879 40.657 21.4175C40.657 17.2669 37.2915 13.9014 33.1409 13.9014C32.6659 13.9014 32.2069 13.9457 31.7561 14.0302C30.6007 12.1381 28.5234 10.874 26.1482 10.874C22.5491 10.874 19.6305 13.7645 19.5781 17.3515C19.5419 17.3515 19.5057 17.3475 19.4694 17.3475C16.124 17.3475 13.4147 20.0568 13.4147 23.4022C13.4147 26.7476 16.124 29.457 19.4694 29.457H41.6997C43.6119 29.3966 45.1498 27.8346 45.1498 25.9062L45.1458 25.9103Z",
    fill: "#F0F0F0"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M137.332 50.3542C137.332 49.5893 136.712 48.9653 135.943 48.9653C135.806 48.9653 135.669 48.9854 135.544 49.0257C135.564 48.8848 135.576 48.7439 135.576 48.5989C135.576 46.9766 134.26 45.6601 132.638 45.6601C132.452 45.6601 132.271 45.6762 132.094 45.7125C131.643 44.9717 130.83 44.4766 129.9 44.4766C128.491 44.4766 127.352 45.6078 127.332 47.0088C127.315 47.0088 127.303 47.0088 127.287 47.0088C125.979 47.0088 124.92 48.0675 124.92 49.3759C124.92 50.6843 125.979 51.7431 127.287 51.7431H135.983C136.732 51.7189 137.332 51.107 137.332 50.3542Z",
    fill: "#F0F0F0"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0258 134.541C123.135 134.541 158.081 132.501 158.081 129.984C158.081 127.467 123.135 125.427 80.0258 125.427C36.9169 125.427 1.97028 127.467 1.97028 129.984C1.97028 132.501 36.9169 134.541 80.0258 134.541Z",
    fill: "#F5F5F5"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M151.467 116.957C151.467 116.957 153.359 110.625 149.535 109.36C145.71 108.096 143.44 105.137 143.568 101.788C143.697 98.4386 139.672 95.1777 136.652 98.3178C133.633 101.458 134.035 95.9023 130.01 94.5537C125.984 93.2051 122.57 96.478 123.673 99.4692C124.776 102.46 120.803 104.332 116.044 101.784C111.286 99.2397 106.052 103.869 107.059 107.493C108.065 111.116 107.24 111.518 104.233 110.311C101.221 109.103 95.839 112.525 97.7271 116.953C99.6151 121.381 151.467 116.953 151.467 116.953V116.957Z",
    fill: "#28BFB2"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.467 116.957C151.467 116.957 153.359 110.625 149.535 109.36C145.71 108.096 143.44 105.137 143.568 101.788C143.697 98.4386 139.672 95.1777 136.652 98.3178C133.633 101.458 134.035 95.9023 130.01 94.5537C125.984 93.2051 122.57 96.478 123.673 99.4692C124.776 102.46 120.803 104.332 116.044 101.784C111.286 99.2397 106.052 103.869 107.059 107.493C108.065 111.116 107.24 111.518 104.233 110.311C101.221 109.103 95.839 112.525 97.7271 116.953C99.6151 121.381 151.467 116.953 151.467 116.953V116.957Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2991 117.561C52.312 115.548 50.5004 112.126 48.4875 111.724C46.4746 111.321 44.4496 107.778 44.357 105.524C44.2604 103.27 40.6372 96.3332 35.0012 100.617C29.3651 104.9 31.0801 101.249 27.002 100.045C22.9239 98.8413 20.3514 102.303 22.1429 104.9C22.1429 104.9 18.0487 103.873 16.3619 107.698C14.6751 111.522 16.3619 113.898 16.3619 113.898C16.3619 113.898 8.66057 113.668 9.353 118.435C10.0454 123.201 50.3031 117.561 50.3031 117.561H50.2991Z",
    fill: "#28BFB2"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.2991 117.561C52.312 115.548 50.5004 112.126 48.4875 111.724C46.4746 111.321 44.4496 107.778 44.357 105.524C44.2604 103.27 40.6372 96.3332 35.0012 100.617C29.3651 104.9 31.0801 101.249 27.002 100.045C22.9239 98.8413 20.3514 102.303 22.1429 104.9C22.1429 104.9 18.0487 103.873 16.3619 107.698C14.6751 111.522 16.3619 113.898 16.3619 113.898C16.3619 113.898 8.66057 113.668 9.353 118.435C10.0454 123.201 50.3031 117.561 50.3031 117.561H50.2991Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M27.151 118.519C25.1381 116.506 26.9497 113.084 28.9626 112.682C30.9754 112.279 33.0004 108.736 33.093 106.482C33.1896 104.228 36.8128 97.2912 42.4489 101.575C48.085 105.858 46.374 102.207 50.4481 101.003C54.5262 99.7993 57.0986 103.261 55.3072 105.858C55.3072 105.858 59.4014 104.831 61.0882 108.656C62.775 112.48 61.0882 114.856 61.0882 114.856C61.0882 114.856 68.7895 114.626 68.097 119.393C67.4046 124.159 27.1469 118.519 27.1469 118.519H27.151Z",
    fill: "#28BFB2"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27.151 118.519C25.1381 116.506 26.9497 113.084 28.9626 112.682C30.9754 112.279 33.0004 108.736 33.093 106.482C33.1896 104.228 36.8128 97.2912 42.4489 101.575C48.085 105.858 46.374 102.207 50.4481 101.003C54.5262 99.7993 57.0986 103.261 55.3072 105.858C55.3072 105.858 59.4014 104.831 61.0882 108.656C62.775 112.48 61.0882 114.856 61.0882 114.856C61.0882 114.856 68.7895 114.626 68.097 119.393C67.4046 124.159 27.1469 118.519 27.1469 118.519H27.151Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M158.392 117.681V123.197H2.99731V117.681C2.99731 116.723 3.66559 115.95 4.62372 115.95H156.765C157.724 115.95 158.392 116.723 158.392 117.681Z",
    fill: "#263238"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5166 115.95H11.8547V123.197H21.5166V115.95Z",
    fill: "#28BFB2"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6326 115.95H30.3733V123.197H39.6326V115.95Z",
    fill: "#28BFB2"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1509 115.95H48.489V123.197H58.1509V115.95Z",
    fill: "#28BFB2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2676 115.95H67.0083V123.197H76.2676V115.95Z",
    fill: "#28BFB2"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3832 115.95H85.124V123.197H94.3832V115.95Z",
    fill: "#28BFB2"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M112.902 115.95H103.24V123.197H112.902V115.95Z",
    fill: "#28BFB2"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M131.018 115.95H121.758V123.197H131.018V115.95Z",
    fill: "#28BFB2"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M149.536 115.95H139.874V123.197H149.536V115.95Z",
    fill: "#28BFB2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.517 115.95H11.8552V123.197H21.517V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6327 115.95H30.3735V123.197H39.6327V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1511 115.95H48.4893V123.197H58.1511V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2678 115.95H67.0085V123.197H76.2678V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3835 115.95H85.1242V123.197H94.3835V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.902 115.95H103.24V123.197H112.902V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.018 115.95H121.759V123.197H131.018V115.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.536 115.95H139.874V123.197H149.536V115.95Z",
    fill: "white"
  }))), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.392 117.681V123.197H2.99731V117.681C2.99731 116.723 3.66559 115.95 4.62372 115.95H156.765C157.724 115.95 158.392 116.723 158.392 117.681Z",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4344 46.9405C26.4344 46.9405 22.7709 48.2691 23.407 50.1209C24.0431 51.9768 28.4231 49.4687 28.4231 49.4687L26.4304 46.9365L26.4344 46.9405Z",
    fill: "#9F5B53"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.4344 46.9405C26.4344 46.9405 22.7709 48.2691 23.407 50.1209C24.0431 51.9768 28.4231 49.4687 28.4231 49.4687L26.4304 46.9365L26.4344 46.9405Z",
    fill: "black"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M32.767 42.8623C30.734 43.2971 25.5568 46.8196 25.5568 46.8196L27.308 51.0185L31.994 49.4726L32.7629 42.8663L32.767 42.8623Z",
    fill: "#28BFB2"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7017 124.15L38.1655 125.611L35.122 120.092L37.6582 118.635L40.7017 124.15Z",
    fill: "#9F5B53"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8553 125.286L40.6734 123.49C40.77 123.426 40.8948 123.434 40.9793 123.514L42.6782 125.282C42.8312 125.459 42.807 125.729 42.6299 125.877C42.6098 125.898 42.5856 125.914 42.5574 125.926C41.5751 126.53 41.0397 126.799 39.8119 127.58C39.059 128.055 35.8666 129.774 34.683 129.859C33.4995 129.944 33.3706 128.824 33.8497 128.647C36.2732 127.741 37.2193 126.586 37.5252 125.68C37.5856 125.515 37.6983 125.374 37.8433 125.282L37.8553 125.286Z",
    fill: "#263238"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.6582 118.635L35.122 120.092L36.6921 122.938L39.2323 121.477L37.6582 118.635Z",
    fill: "black"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5771 59.4122C30.5771 59.4122 22.2719 86.9364 22.7309 95.1167C23.2301 104.086 35.2872 122.955 35.2872 122.955L39.8323 120.085C39.8323 120.085 31.3138 101.494 30.9958 94.6095C31.4668 84.6498 41.817 60.4589 41.817 60.4589L30.5771 59.4082V59.4122Z",
    fill: "#263238"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.1671 69.0857C34.655 70.6195 33.6606 77.1735 34.192 80.4988C35.5487 76.2878 37.0986 72.1372 38.3386 68.9529C37.9521 68.7838 37.5052 68.8321 37.1671 69.0857Z",
    fill: "black"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7835 123.394L40.1417 120L39.2641 118.49L33.6442 121.916L34.7835 123.394Z",
    fill: "#263238"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2754 126.215C37.1144 126.332 36.9251 126.397 36.7279 126.397C36.5991 126.38 36.4863 126.3 36.438 126.179C36.3978 126.111 36.3978 126.026 36.438 125.962C36.6393 125.652 37.7102 125.604 37.8309 125.604C37.8551 125.604 37.8793 125.616 37.8873 125.64C37.8994 125.668 37.8873 125.696 37.8712 125.716C37.69 125.901 37.4928 126.07 37.2794 126.215H37.2754ZM36.6232 125.966C36.595 125.982 36.5749 126.006 36.5548 126.03C36.5387 126.054 36.5387 126.091 36.5548 126.115C36.587 126.199 36.6635 126.26 36.752 126.264C37.1063 126.203 37.4243 126.022 37.6578 125.748C37.3036 125.756 36.9533 125.829 36.6232 125.962V125.966Z",
    fill: "#28BFB2"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8635 125.733H37.8313C37.4971 125.765 36.7 125.564 36.5994 125.27C36.5672 125.169 36.6115 125.06 36.704 125.008C36.7846 124.94 36.8892 124.907 36.9939 124.919C37.4126 124.96 37.8675 125.596 37.8836 125.636C37.8997 125.656 37.8997 125.684 37.8836 125.705C37.8796 125.717 37.8715 125.725 37.8635 125.733ZM36.8087 125.101L36.7846 125.117C36.7121 125.173 36.7282 125.209 36.7322 125.229C36.7886 125.403 37.3361 125.588 37.6944 125.608C37.5495 125.427 37.2435 125.085 36.9778 125.06C36.9214 125.056 36.8611 125.068 36.8127 125.101H36.8087Z",
    fill: "#28BFB2"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2298 127.471H43.4117L43.1782 120.938H46.0003L46.2298 127.471Z",
    fill: "#9F5B53"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0204 127.146H46.4463C46.563 127.146 46.6597 127.226 46.6878 127.339L47.2434 129.851C47.2917 130.076 47.1468 130.298 46.9213 130.346C46.8932 130.354 46.8609 130.354 46.8287 130.354C45.7216 130.338 44.9125 130.27 43.5196 130.27C42.6621 130.27 40.0735 130.358 38.8899 130.358C37.7064 130.358 37.5534 129.187 38.0365 129.082C40.2104 128.607 41.8448 127.951 42.5413 127.327C42.6701 127.21 42.8392 127.146 43.0163 127.146H43.0204Z",
    fill: "#263238"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.0003 120.942H43.1782L43.299 124.312H46.1251L46.0003 120.942Z",
    fill: "black"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4255 59.9718C34.4255 59.9718 36.7202 86.9364 37.9118 95.1167C39.2161 104.086 42.002 123.655 42.002 123.655H47.163C47.163 123.655 46.1082 104.928 45.6211 96.1111C45.0615 86.0668 44.7959 60.8212 44.7959 60.8212L34.4295 59.9678L34.4255 59.9718Z",
    fill: "#263238"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3819 123.768H47.4688V121.949L41.1524 121.832L41.3819 123.768Z",
    fill: "#263238"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0859 127.641C41.8926 127.657 41.7034 127.605 41.5424 127.496C41.4377 127.408 41.3854 127.275 41.4015 127.138C41.4015 127.057 41.4458 126.985 41.5182 126.953C41.8322 126.792 42.7421 127.351 42.8427 127.416C42.8669 127.428 42.8789 127.452 42.8749 127.48C42.8749 127.508 42.8508 127.528 42.8266 127.537C42.5851 127.597 42.3355 127.633 42.0859 127.641ZM41.6672 127.057C41.639 127.057 41.6068 127.057 41.5826 127.074C41.5665 127.074 41.5424 127.098 41.5384 127.154C41.5263 127.243 41.5625 127.335 41.6269 127.396C41.945 127.541 42.3033 127.557 42.6334 127.444C42.3395 127.255 42.0134 127.122 41.6672 127.057Z",
    fill: "#28BFB2"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8069 127.54H42.7747C42.4849 127.383 41.9213 126.763 41.9776 126.465C41.9978 126.364 42.0903 126.288 42.191 126.288C42.2916 126.276 42.3963 126.304 42.4728 126.372C42.7989 126.638 42.8673 127.447 42.8713 127.488C42.8713 127.512 42.8593 127.536 42.8391 127.548C42.8271 127.548 42.815 127.548 42.8029 127.536L42.8069 127.54ZM42.2393 126.397H42.2071C42.1225 126.397 42.1145 126.445 42.1105 126.465C42.0742 126.65 42.4325 127.117 42.7224 127.339C42.7023 127.017 42.5855 126.711 42.3882 126.457C42.348 126.421 42.2916 126.401 42.2393 126.401V126.397Z",
    fill: "#28BFB2"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2714 64.2714L39.4976 64.3559V62.5967H32.2714V64.2714Z",
    fill: "black"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0447 62.5967V64.364L44.9844 64.4244V62.5967H40.0447Z",
    fill: "black"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7237 62.5967H29.6223L29.425 64.2352L31.7237 64.2633V62.5967Z",
    fill: "black"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6234 62.2744H33.7812V64.3235H36.6234V62.2744Z",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7471 62.3471L45.1175 63.3656C45.9589 55.9099 48.4106 48.2448 49.1392 45.5395C49.2439 45.149 49.0225 44.7424 48.632 44.6297C47.8711 44.4123 47.0821 44.211 46.289 44.0339C42.2874 43.1401 38.0402 42.7456 35.3872 42.5725C33.7648 42.4678 32.7705 42.8583 32.7705 42.8583C30.4637 49.3962 29.9202 57.3873 29.7512 62.343L29.7471 62.3471Z",
    fill: "#28BFB2"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M47.7061 50.6323C47.5611 51.1879 47.4041 51.7716 47.2512 52.3755C46.4138 55.6242 45.5523 59.5252 45.1175 63.3658L29.7471 62.3473C29.8679 58.7643 30.1859 53.5953 31.2246 48.5389C31.2246 48.5389 31.2246 48.5349 31.2286 48.5349C32.7665 45.0123 36.6231 43.4785 36.6231 43.4785C36.6231 43.4785 37.0499 44.3883 38.9621 44.654C40.8743 44.9197 43.4267 44.3239 43.4267 44.3239C46.4017 46.675 47.1626 50.9946 47.1626 50.9946C47.1626 50.9946 47.3719 50.8577 47.7061 50.6323Z",
    fill: "white"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.5279 47.7017C48.1616 48.9819 47.7107 50.5761 47.2517 52.3756C45.569 50.0084 47.0706 46.5664 47.0706 46.5664C47.6503 46.7838 48.1334 47.1904 48.5239 47.6976L48.5279 47.7017Z",
    fill: "black"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5284 43.5672C42.2079 44.7669 38.9752 44.32 38.9752 44.32C38.9752 44.32 36.9543 43.7685 37.377 43.1365C38.5686 42.9432 39.1443 42.3877 39.3818 41.6751C39.5187 41.2645 39.5388 40.7975 39.5026 40.3184C39.4945 40.2057 39.4825 40.093 39.4664 39.9843C39.4503 39.8434 39.4261 39.7025 39.4019 39.5616L43.3995 36.5986C43.2546 37.1381 43.1016 37.8064 42.9809 38.5189C42.699 40.1977 42.6105 42.126 43.2868 43.2371C43.3553 43.3579 43.4398 43.4666 43.5284 43.5672Z",
    fill: "#9F5B53"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.8604 41.977C41.403 41.816 40.3161 40.8739 39.4062 39.5615L42.7798 39.8433C42.7436 40.5036 42.7798 41.2201 42.8604 41.977Z",
    fill: "black"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M23.387 49.4318C23.0528 51.501 24.2847 52.1049 29.1478 57.8376C29.1478 57.8376 28.8378 58.7716 28.9868 58.997C29.1357 59.2225 31.9659 62.0848 31.9659 62.0848L34.3894 58.9286C34.3894 58.9286 32.618 56.7587 32.0504 56.3642C31.8089 56.1991 30.6897 56.2434 30.6897 56.2434C30.6897 56.2434 26.5794 49.2667 25.7622 48.6226C24.9449 47.9785 23.6084 48.063 23.387 49.4318Z",
    fill: "#9F5B53"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0356 52.7336C51.0356 52.7336 53.6564 56.236 56.0919 55.6483C58.5275 55.0605 61.0396 52.8302 61.0396 52.8302C61.0396 52.8302 62.1829 53.5468 62.7184 53.5347C63.2538 53.5227 66.0758 53.0396 66.0758 53.0396L64.7554 50.0323C64.7554 50.0323 62.3037 50.1934 61.6555 50.1773C61.0074 50.1611 60.2143 51.1837 60.2143 51.1837C60.2143 51.1837 56.3375 52.166 55.782 52.1418C55.2264 52.1177 53.3222 49.9961 53.3222 49.9961L51.0396 52.7296L51.0356 52.7336Z",
    fill: "#9F5B53"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6324 44.6299C50.8828 45.6846 55.3635 50.9745 55.3635 50.9745L52.0221 54.8271L47.163 50.9946C47.163 50.9946 46.6839 47.927 47.0704 46.5663C47.4569 45.2056 48.6324 44.6299 48.6324 44.6299Z",
    fill: "#28BFB2"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.7835 123.394L40.1417 120L39.2641 118.49L33.6442 121.916L34.7835 123.394Z",
    fill: "black"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.3819 123.768H47.4688V121.949L41.1524 121.832L41.3819 123.768Z",
    fill: "black"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2578 34.7948C36.1773 35.1329 36.3826 35.4711 36.7168 35.5516C37.0509 35.6321 37.3931 35.4268 37.4736 35.0927C37.5541 34.7545 37.3488 34.4164 37.0147 34.3358C36.6765 34.2553 36.3383 34.4606 36.2578 34.7948Z",
    fill: "#263238"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8632 30.4386C45.8632 30.4386 46.8455 34.2067 44.9695 35.8935C43.0894 37.5803 42.3447 30.4466 42.3447 30.4466L45.8672 30.4346L45.8632 30.4386Z",
    fill: "#263238"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6823 38.0674C45.6421 38.2003 45.5938 38.3291 45.5374 38.4579C45.3442 38.9169 45.0624 39.3194 44.7282 39.6576C44.378 40.0159 43.9633 40.2937 43.5165 40.4909C42.7033 40.8452 41.7854 40.9136 40.9319 40.6238C40.3683 40.4346 39.8329 40.0883 39.382 39.561C38.0736 38.0594 38.2145 36.433 38.2306 33.6632C38.2266 33.0674 38.3554 32.4756 38.6211 31.9482C39.543 30.0682 41.8176 29.2993 43.6896 30.2252C46.3224 31.5014 46.4352 35.6278 45.6823 38.0714V38.0674Z",
    fill: "#9F5B53"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3773 34.7062C42.3491 34.9276 42.4699 35.1209 42.6188 35.1289C42.7678 35.137 42.8966 34.9638 42.9127 34.7384C42.9288 34.513 42.8201 34.3238 42.6712 34.3157C42.5262 34.3076 42.3934 34.4808 42.3773 34.7062Z",
    fill: "#263238"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9176 34.8712C44.8895 35.0926 45.0143 35.2859 45.1592 35.2939C45.3041 35.302 45.437 35.1289 45.4531 34.9034C45.4692 34.678 45.3605 34.4888 45.2115 34.4807C45.0666 34.4727 44.9337 34.6579 44.9176 34.8712Z",
    fill: "#263238"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1037 34.9277C44.3251 35.6322 44.6471 36.3045 45.0537 36.9205C44.7277 37.1258 44.3251 37.1701 43.9587 37.0533L44.1037 34.9277Z",
    fill: "#892B29"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9318 33.8448C45.8876 33.8649 45.8352 33.8609 45.795 33.8327C45.5252 33.6315 45.179 33.567 44.8529 33.6596C44.7845 33.6878 44.708 33.6516 44.6839 33.5831C44.6557 33.5147 44.6919 33.4382 44.7563 33.4141C45.1629 33.2852 45.6058 33.3617 45.9439 33.6154C46.0043 33.6556 46.0204 33.7361 45.9802 33.7965C45.9802 33.7965 45.9479 33.8287 45.9318 33.8408V33.8448Z",
    fill: "#263238"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9381 33.6557C41.9099 33.6557 41.8858 33.6436 41.8656 33.6234C41.8213 33.5671 41.8334 33.4825 41.8898 33.4383C42.2239 33.1726 42.6708 33.088 43.0774 33.2128C43.1458 33.237 43.182 33.3135 43.1539 33.3819C43.1257 33.4503 43.0532 33.4825 42.9848 33.4584C42.6587 33.3698 42.3125 33.4423 42.0468 33.6516C42.0106 33.6677 41.9703 33.6677 41.9341 33.6516L41.9381 33.6557Z",
    fill: "#263238"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4848 30.3457L40.6137 31.5695C40.2111 31.7749 39.9615 32.2217 40.1386 32.7088C40.517 33.7435 39.9051 35.3256 39.108 35.9455C39.108 35.9455 39.0919 35.4987 38.7135 35.5993C38.3351 35.7 38.3995 38.0148 39.112 39.1339C39.112 39.1339 38.0211 38.1154 37.4373 35.6758C36.8979 33.4174 36.8576 31.5414 37.3367 30.6798L40.4848 30.3497V30.3457Z",
    fill: "#263238"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8777 35.8496C37.1434 36.4938 37.6547 37.0091 38.2988 37.2748C39.1522 37.625 39.6877 36.8843 39.5427 36.0228C39.4059 35.2579 38.802 34.1266 37.9002 34.1508C36.9985 34.1749 36.5637 35.0525 36.8817 35.8456L36.8777 35.8496Z",
    fill: "#9F5B53"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9431 37.8019C43.6935 38.1602 43.3795 38.8566 43.3795 38.8566C43.3111 38.8405 43.2426 38.8244 43.1742 38.8043C42.2523 38.5547 41.9061 38.132 41.8054 37.7415C41.7491 37.5281 41.7692 37.3228 41.8054 37.1578C41.8457 36.9686 41.9182 36.8438 41.9182 36.8438C42.3288 37.2705 43.1702 37.5684 43.6251 37.7093C43.8143 37.7697 43.9391 37.7979 43.9391 37.7979L43.9431 37.8019Z",
    fill: "#263238"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6325 37.7094L43.4594 38.0154C42.5939 37.7778 42.0142 37.492 41.8129 37.1539C41.8531 36.9646 41.9256 36.8398 41.9256 36.8398C42.3362 37.2666 43.1776 37.5645 43.6325 37.7054V37.7094Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1783 38.804C42.2564 38.5544 41.9102 38.1317 41.8096 37.7412C42.1196 37.8378 42.4859 37.9908 42.7798 38.2243C43.0052 38.4014 43.122 38.6108 43.1824 38.804H43.1783Z",
    fill: "#DE5753"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3743 31.3889C36.2576 31.872 36.5515 32.3591 37.0346 32.4759C37.5176 32.5926 38.0048 32.2987 38.1215 31.8157C38.2383 31.3326 37.9444 30.8454 37.4613 30.7287C36.9782 30.6119 36.4911 30.9058 36.3743 31.3889Z",
    fill: "#263238"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4748 32.7538C36.3942 33.0919 36.5996 33.4301 36.9337 33.5106C37.2719 33.5911 37.61 33.3858 37.6905 33.0517C37.771 32.7175 37.5657 32.3753 37.2316 32.2948C36.8934 32.2143 36.5553 32.4196 36.4748 32.7538Z",
    fill: "#263238"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3908 33.6073C36.3103 33.9454 36.5156 34.2836 36.8497 34.3641C37.1879 34.4446 37.526 34.2393 37.6066 33.9052C37.6871 33.567 37.4818 33.2289 37.1476 33.1483C36.8135 33.0678 36.4713 33.2731 36.3908 33.6073Z",
    fill: "#263238"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8498 31.1672C36.8498 31.1672 36.5921 29.5609 39.1445 28.3773C41.6968 27.1937 44.4182 28.6994 46.1332 27.6688C47.8442 26.6382 47.7838 31.0665 44.1727 31.4651C40.5616 31.8676 36.8498 31.1712 36.8498 31.1712V31.1672Z",
    fill: "#263238"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9151 27.7294C41.7379 28.45 42.1808 29.1787 42.9014 29.3558C43.622 29.533 44.3506 29.0901 44.5278 28.3695C44.7049 27.6489 44.2621 26.9203 43.5415 26.7431C42.8209 26.566 42.0922 27.0088 41.9151 27.7294Z",
    fill: "#263238"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1505 28.1923C37.9733 28.9129 38.4162 29.6416 39.1368 29.8187C39.8574 29.9959 40.5861 29.553 40.7632 28.8324C40.9403 28.1118 40.4975 27.3831 39.7769 27.206C39.0563 27.0289 38.3276 27.4717 38.1505 28.1923Z",
    fill: "#263238"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7028 29.2717C45.5861 29.7548 45.8799 30.2419 46.363 30.3587C46.8461 30.4754 47.3332 30.1816 47.45 29.6985C47.5667 29.2154 47.2729 28.7283 46.7898 28.6115C46.3067 28.4948 45.8196 28.7886 45.7028 29.2717Z",
    fill: "#263238"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5663 27.4153C40.4495 27.8984 40.7434 28.3855 41.2265 28.5022C41.7096 28.619 42.1967 28.3251 42.3135 27.842C42.4302 27.3589 42.1363 26.8718 41.6532 26.7551C41.1701 26.6383 40.683 26.9322 40.5663 27.4153Z",
    fill: "#263238"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9665 29.2395C36.8497 29.7226 37.1436 30.2097 37.6267 30.3265C38.1098 30.4432 38.5969 30.1493 38.7137 29.6662C38.8304 29.1831 38.5365 28.696 38.0534 28.5793C37.5704 28.4625 37.0832 28.7564 36.9665 29.2395Z",
    fill: "#263238"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4547 27.8947C44.2775 28.6233 44.7244 29.3601 45.449 29.5372C46.1777 29.7143 46.9144 29.2715 47.0915 28.5428C47.2687 27.8142 46.8218 27.0775 46.0972 26.9003C45.3685 26.7232 44.6318 27.166 44.4547 27.8947Z",
    fill: "#263238"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9051 51.8317L69.4043 57.2785C70.2175 57.2463 70.5234 55.3784 70.6523 53.8727L69.8713 52.3751L70.6523 50.8574H73.0476L73.5951 52.5241L73.2972 53.8727L72.1136 54.4444C72.1136 54.4444 71.2843 61.2278 70.2376 61.2278C69.1909 61.2278 62.3874 55.2978 62.3874 55.2978L63.9051 51.8317Z",
    fill: "#EEC1BB"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4358 55.8005L65.4551 58.2723L67.8948 54.4196L63.9052 51.8311L62.4358 55.8005Z",
    fill: "#263238"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.1231 57.1853L64.5901 54.8262L65.4557 58.2722L64.1231 57.1853Z",
    fill: "black"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M64.464 63.5098V67.3463L54.0373 68.071L53.5784 64.0251L64.464 63.5098Z",
    fill: "#EEC1BB"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9594 127.527L72.6567 127.934L71.7106 124.794L70.8491 121.911L73.5061 120.985L74.275 124.448L74.9594 127.527Z",
    fill: "#EEC1BB"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.2865 124.519L71.722 124.858L70.8525 121.943L73.5055 121.001L74.2865 124.519Z",
    fill: "black"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8329 127.547C75.8128 127.535 75.8007 127.511 75.8007 127.487C75.8007 127.447 75.8732 126.638 76.1992 126.372C76.2757 126.303 76.3804 126.271 76.481 126.287C76.5857 126.287 76.6743 126.36 76.6944 126.464C76.7508 126.762 76.1872 127.382 75.8973 127.539H75.8651C75.8651 127.539 75.841 127.551 75.8289 127.551L75.8329 127.547ZM76.2838 126.448C76.0865 126.702 75.9698 127.008 75.9496 127.33C76.2395 127.113 76.5978 126.642 76.5616 126.456C76.5616 126.44 76.5495 126.388 76.4649 126.388H76.4327C76.3764 126.388 76.324 126.408 76.2838 126.444V126.448Z",
    fill: "#263238"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5804 128.59H57.2454L56.8589 125.293L56.5127 122.286L59.2865 121.827L59.4475 125.406L59.5804 128.59Z",
    fill: "#EEC1BB"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.4475 125.434L56.8589 125.321L56.5127 122.302L59.2864 121.835L59.4475 125.434Z",
    fill: "black"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5049 122.693L70.7207 123.361C66.9002 113.844 64.1829 105.897 62.2626 99.3032C61.2279 95.7444 60.3664 92.5802 59.7465 89.7742L59.8632 100.137V123.478H56.1313C46.7795 78.9328 53.4059 68.7839 53.4059 68.7839L64.5935 66.9199C65.0202 68.5906 65.3423 71.3241 65.5315 73.2082L66.0347 76.9199L70.4107 99.5125L74.5049 122.697V122.693Z",
    fill: "#28BFB2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5049 122.693L70.7206 123.361C66.9002 113.844 64.1828 105.897 62.2625 99.3032C61.2279 95.7444 60.3664 92.5802 59.7464 89.7742L59.8631 100.137V123.478H56.1313C46.7794 78.9328 53.4058 68.7839 53.4058 68.7839L64.5934 66.9199C65.0202 68.5906 65.3422 71.3241 65.5314 73.2082L66.0346 76.9199L70.4107 99.5125L74.5049 122.697V122.693Z",
    fill: "white"
  }))), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.2619 99.3034C61.2273 95.7447 60.4221 92.5804 59.8022 89.7745C59.8022 89.7745 59.8625 84.3195 60.5228 79.8389C60.5228 79.8389 62.1612 92.6569 62.2579 99.3034H62.2619Z",
    fill: "black"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4068 68.8319L52.5002 69.9108C52.9068 67.3745 53.088 63.0871 52.2667 60.1765C52.142 59.7417 52.0051 59.2828 51.8521 58.7916C51.675 58.228 51.4737 57.6241 51.2482 56.976C51.0751 56.4768 50.8859 55.9454 50.6766 55.3858C50.6202 55.2208 50.5558 55.0517 50.4914 54.8826C50.282 54.315 50.0566 53.7111 49.807 53.075C51.3006 52.6523 52.8263 52.3222 54.3682 52.0927C55.9986 51.8351 57.6492 51.6821 59.3078 51.6298C61.4455 51.6137 63.9052 51.827 63.9052 51.827C63.9052 51.827 64.2514 51.9035 64.4729 53.9245C64.6742 55.8246 65.8497 61.9196 65.4109 68.8278L65.4068 68.8319Z",
    fill: "#263238"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M59.183 52.2745C59.0864 52.2221 58.9696 52.1738 58.8489 52.1295C58.5952 51.9282 58.2853 51.4451 58.3014 50.2736C58.3054 49.8912 58.3416 49.4403 58.4302 48.9009L55.1693 48.293C55.1693 48.293 56.2804 50.487 55.3545 52.1174C55.0365 52.2583 54.8432 52.4596 54.8795 52.7253C55.125 54.6094 58.716 54.9798 58.716 54.9798C58.716 54.9798 61.1516 53.3534 59.187 52.2745H59.183Z",
    fill: "#EEC1BB"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.4263 48.9049C58.0438 49.9395 57.1904 50.6601 55.7008 50.9419C55.7572 50.0804 55.5841 49.1988 55.1614 48.293L58.4222 48.9009L58.4263 48.9049Z",
    fill: "black"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0883 37.9866C60.0883 37.9866 59.6736 34.5124 62.8781 35.6557C66.0867 36.795 65.6559 42.5961 67.1897 44.5084C68.7235 46.4206 69.8709 46.2153 69.8709 46.2153C69.8709 46.2153 67.9546 47.8014 66.1189 46.9238C64.2831 46.0462 60.0883 37.9866 60.0883 37.9866Z",
    fill: "#263238"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0437 38.5221L60.7965 38.0068C60.7965 38.0068 61.6379 38.1477 62.121 39.0334C62.6 39.9191 62.6202 40.7121 62.6202 40.7121L61.5976 41.151L60.0437 38.5221Z",
    fill: "#28BFB2"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2234 38.4453C56.2234 38.4453 52.3748 38.1756 51.8474 41.2875C51.316 44.3994 53.7838 45.9775 53.7838 45.9775L56.2234 38.4413V38.4453Z",
    fill: "#263238"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6624 40.0635C53.8242 40.0635 52.9104 41.5893 52.705 44.516C52.4514 48.1714 53.2646 50.768 56.8113 49.983C61.6302 48.9161 61.3765 40.0554 56.6583 40.0635H56.6624Z",
    fill: "#EEC1BB"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5407 44.3555C54.5407 44.3555 54.1462 45.0962 53.7155 45.535C53.7155 45.535 53.957 45.9215 54.4642 45.8571L54.5407 44.3595V44.3555Z",
    fill: "#D4827D"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2807 44.1217C56.2767 44.3552 56.3974 44.5484 56.5544 44.5484C56.7114 44.5484 56.8403 44.3673 56.8443 44.1338C56.8483 43.9003 56.7275 43.707 56.5705 43.707C56.4135 43.707 56.2847 43.8882 56.2807 44.1217Z",
    fill: "#263238"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6353 43.7152L56.1321 43.5059C56.1321 43.5059 56.3737 43.9406 56.6353 43.7152Z",
    fill: "#263238"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3811 44.0094C53.3771 44.2429 53.4979 44.4361 53.6549 44.4361C53.8119 44.4361 53.9407 44.255 53.9447 44.0215C53.9488 43.788 53.828 43.5947 53.675 43.5947C53.518 43.5947 53.3892 43.7759 53.3852 44.0094H53.3811Z",
    fill: "#263238"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7352 43.6029L53.2319 43.3936C53.2319 43.3936 53.4735 43.8243 53.7352 43.6029Z",
    fill: "#263238"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3041 42.1617C56.3041 42.1617 57.1012 42.057 57.536 42.5884",
    stroke: "#263238",
    strokeWidth: 0.483389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2425 42.0408C54.2425 42.0408 53.7392 41.8556 53.1112 42.2743",
    stroke: "#263238",
    strokeWidth: 0.483389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M59.77 44.8467C59.77 44.8467 58.4415 42.5157 58.6388 40.7122C58.6388 40.7122 53.0108 38.4215 52.737 44.1301C52.737 44.1301 52.1815 39.0576 57.0607 38.9409C61.9359 38.8241 61.9278 45.9618 59.4117 48.0955C59.4117 48.0955 60.5913 46.304 59.766 44.8467H59.77Z",
    fill: "#263238"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7286 38.2526C55.7286 38.2526 53.3695 37.8138 52.7455 38.462C52.1215 39.1142 57.0611 43.1963 59.545 43.4982C59.545 43.4982 60.5313 46.1754 59.9435 47.4837C59.9435 47.4837 62.6569 46.3646 62.5522 42.1415C62.4476 37.9185 57.9266 36.586 55.7286 38.2526Z",
    fill: "#263238"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3067 45.4467C59.3268 44.9878 59.7979 44.2148 60.6473 44.3074C61.5289 44.404 61.9476 46.2076 59.7616 46.6464C59.4476 46.7108 59.2705 46.4008 59.3107 45.4467H59.3067Z",
    fill: "#EEC1BB"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1898 46.8594C54.4233 47.2298 54.697 47.9424 54.697 47.9424C54.7654 47.9303 54.8339 47.9142 54.9023 47.8981C55.8363 47.6928 56.2026 47.2902 56.3234 46.9037C56.3878 46.6944 56.3798 46.485 56.3516 46.32C56.3194 46.1308 56.255 46.002 56.255 46.002C55.8242 46.4045 54.9708 46.6622 54.5078 46.783C54.3146 46.8353 54.1898 46.8594 54.1898 46.8594Z",
    fill: "#263238"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5037 46.7869L54.6607 47.1009C55.5383 46.9076 56.1301 46.65 56.3475 46.3239C56.3153 46.1347 56.2509 46.0059 56.2509 46.0059C55.8201 46.4084 54.9667 46.6661 54.5037 46.7869Z",
    fill: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9018 47.9016C55.8358 47.6963 56.2021 47.2937 56.3229 46.9072C56.0089 46.9877 55.6345 47.1246 55.3325 47.338C55.0991 47.503 54.9743 47.7043 54.9018 47.8976V47.9016Z",
    fill: "#DE5753"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M75.849 127.536C75.8208 127.528 75.8007 127.507 75.8007 127.479C75.7966 127.451 75.8087 127.427 75.8329 127.415C75.9335 127.35 76.8433 126.791 77.1573 126.952C77.2298 126.984 77.2741 127.061 77.2741 127.137C77.2942 127.274 77.2419 127.407 77.1332 127.495C76.9762 127.604 76.7829 127.652 76.5897 127.64C76.3401 127.632 76.0905 127.6 75.849 127.536ZM76.0422 127.443C76.3723 127.556 76.7306 127.536 77.0486 127.395C77.1171 127.334 77.1493 127.246 77.1372 127.153C77.1372 127.101 77.1131 127.073 77.0929 127.073C77.0648 127.056 77.0366 127.052 77.0084 127.056C76.6662 127.121 76.3361 127.254 76.0422 127.443Z",
    fill: "#263238"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1489 127.536C60.1207 127.528 60.1006 127.507 60.1006 127.479C60.0966 127.451 60.1087 127.427 60.1328 127.415C60.2335 127.35 61.1433 126.791 61.4573 126.952C61.5298 126.984 61.574 127.061 61.574 127.137C61.5942 127.274 61.5418 127.407 61.4331 127.495C61.2761 127.604 61.0829 127.652 60.8897 127.64C60.6401 127.632 60.3905 127.6 60.1489 127.536ZM60.3422 127.443C60.6723 127.556 61.0306 127.536 61.3486 127.395C61.417 127.334 61.4493 127.246 61.4372 127.153C61.4372 127.101 61.413 127.073 61.3929 127.073C61.3647 127.056 61.3365 127.052 61.3083 127.056C60.9662 127.121 60.636 127.254 60.3422 127.443Z",
    fill: "#263238"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1328 127.547C60.1126 127.535 60.1006 127.511 60.1006 127.487C60.1006 127.447 60.173 126.638 60.4991 126.372C60.5756 126.303 60.6803 126.271 60.7809 126.287C60.8856 126.287 60.9741 126.36 60.9943 126.464C61.0506 126.762 60.487 127.382 60.1972 127.539H60.165C60.165 127.539 60.1408 127.551 60.1287 127.551L60.1328 127.547ZM60.5837 126.448C60.3864 126.702 60.2696 127.008 60.2495 127.33C60.5394 127.113 60.8977 126.642 60.8614 126.456C60.8614 126.44 60.8494 126.388 60.7648 126.388H60.7326C60.6762 126.388 60.6239 126.408 60.5837 126.444V126.448Z",
    fill: "#263238"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6558 127.146H72.2299C72.1132 127.146 72.0165 127.226 71.9884 127.339L71.4328 129.851C71.3845 130.076 71.5294 130.298 71.7549 130.346C71.7831 130.354 71.8153 130.354 71.8475 130.354C72.9546 130.338 73.7637 130.27 75.1566 130.27C76.0141 130.27 78.6027 130.358 79.7863 130.358C80.9699 130.358 81.1228 129.187 80.6397 129.082C78.4658 128.607 76.8314 127.951 76.1349 127.327C76.0061 127.21 75.837 127.146 75.6599 127.146H75.6558Z",
    fill: "#28BFB2"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9558 127.146H56.5299C56.4132 127.146 56.3165 127.226 56.2884 127.339L55.7328 129.851C55.6845 130.076 55.8294 130.298 56.0549 130.346C56.083 130.354 56.1152 130.354 56.1475 130.354C57.2545 130.338 58.0637 130.27 59.4566 130.27C60.3141 130.27 62.9027 130.358 64.0863 130.358C65.2698 130.358 65.4228 129.187 64.9397 129.082C62.7658 128.607 61.1313 127.951 60.4349 127.327C60.3061 127.21 60.137 127.146 59.9599 127.146H59.9558Z",
    fill: "#28BFB2"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.8513 58.7956C51.6742 58.232 51.4729 57.6282 51.2474 56.98C51.0743 56.4808 50.8851 55.9494 50.6758 55.3898C50.7925 55.1241 50.9415 54.8947 51.1307 54.7256C51.1307 54.7256 51.9681 57.0203 51.8513 58.7956Z",
    fill: "black"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8064 53.0791C48.3451 53.7997 43.9811 60.7079 45.2251 63.059C46.4691 65.41 52.0649 67.439 52.0649 67.439C52.0649 67.439 49.7299 68.7273 49.8104 69.0453C49.891 69.3633 51.8314 70.6677 52.0649 70.6677C52.1695 70.6677 53.6108 69.3633 53.9489 68.9769C54.2267 68.6628 53.9852 67.3424 53.9852 67.3424C52.4071 66.0582 48.0713 62.9664 47.8056 62.278C47.5399 61.5855 51.1913 56.815 51.1913 56.815C51.1913 56.815 51.296 54.8303 50.8571 53.9487C50.4264 53.0831 49.8064 53.0831 49.8064 53.0831V53.0791Z",
    fill: "#EEC1BB"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5408 59.7216L46.292 57.282C47.5561 55.5308 48.5545 53.0227 49.8065 53.0791C51.0062 53.1555 51.2678 54.8746 51.2477 56.98L49.5408 59.7216Z",
    fill: "#263238"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M125.536 36.2041C125.536 36.2041 122.569 34.5535 120.15 35.7814C119.035 36.349 118.644 37.7902 118.407 38.9134C118.076 40.4834 118.028 42.0978 117.803 43.688C117.706 44.3603 117.545 45.0124 117.235 45.6203C116.824 46.4255 115.983 47.2306 116.148 48.2169C116.297 49.0865 117.187 49.6099 117.96 49.8474C120.017 50.4794 122.348 50.1292 124.473 50.262C126.184 50.3707 127.835 50.9464 129.554 50.9907C130.041 51.0028 130.548 50.9625 130.967 50.7089C132.622 49.7226 131.901 47.1823 131.366 45.7733C130.915 44.5817 131.249 43.3498 131.1 42.0978C130.971 41.0028 130.758 39.8997 130.327 38.8812C129.469 36.8482 127.746 35.7693 125.532 36.2L125.536 36.2041Z",
    fill: "#263238"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M111.289 57.5048C111.841 57.4564 117.296 53.9178 117.296 53.9178L117.485 52.4403L117.69 50.8381C116.869 50.8059 111.994 54.7149 111.293 55.0571C109.872 55.7535 110.033 57.6134 111.293 57.5088L111.289 57.5048Z",
    fill: "#EBB376"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.823 54.8552L117.292 53.9132L117.497 52.3311L115.823 54.8552Z",
    fill: "black"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M131.736 51.4412C131.736 51.4412 129.296 53.9251 128.998 64.4686L118.072 63.5869C118.072 63.5869 116.333 56.0628 117.682 50.7447C117.682 50.7447 124.171 49.0459 131.736 51.4452V51.4412Z",
    fill: "#28BFB2"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M131.736 51.4412C131.736 51.4412 129.296 53.9251 128.998 64.4686L118.072 63.5869C118.072 63.5869 116.333 56.0628 117.682 50.7447C117.682 50.7447 124.171 49.0459 131.736 51.4452V51.4412Z",
    fill: "white"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M108.495 124.336L110.681 124.718L111.579 121.743L112.396 119.006L109.876 118.128L109.144 121.413L108.495 124.336Z",
    fill: "#EBB376"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M109.131 121.482L111.566 121.8L112.388 119.038L109.872 118.145L109.131 121.482Z",
    fill: "black"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M123.08 125.343H125.303L125.665 122.219L125.995 119.364L123.362 118.93L123.213 122.323L123.08 125.343Z",
    fill: "#EBB376"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.213 122.351L125.665 122.243L125.995 119.376L123.362 118.934L123.213 122.351Z",
    fill: "black"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M108.926 119.747L112.517 120.379C116.14 111.349 118.721 103.813 120.54 97.557C121.522 94.1834 122.34 91.1802 122.927 88.5191L122.819 98.35V120.492H126.357C135.23 78.2373 128.857 65.8621 128.857 65.8621L118.068 65.1777C117.666 66.7639 117.621 71.0151 117.44 72.8025L116.961 76.3251L112.811 97.7542L108.926 119.747Z",
    fill: "#263238"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.54 97.5609C121.522 94.1873 122.283 91.1841 122.871 88.5231C122.871 88.5231 122.81 83.3459 122.186 79.0947C122.186 79.0947 120.632 91.2525 120.54 97.5609Z",
    fill: "black"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M128.994 64.4686L118.073 63.5869V65.4388L129.156 66.4211L128.994 64.4686Z",
    fill: "black"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M121.092 64.4042V65.2657C121.092 65.616 121.354 65.9058 121.704 65.934L123.056 66.0548C123.056 66.0548 123.097 66.0548 123.117 66.0548C123.282 66.0548 123.447 65.9904 123.572 65.8777C123.709 65.7488 123.789 65.5717 123.789 65.3825V64.517C123.789 64.1667 123.523 63.8769 123.173 63.8487L121.821 63.7319C121.631 63.7158 121.446 63.7802 121.309 63.905C121.172 64.0339 121.092 64.211 121.092 64.4002V64.4042ZM121.438 65.2657V64.9839C121.438 64.9839 121.45 64.988 121.454 64.988L121.833 65.0161C121.957 65.0242 122.07 64.9316 122.078 64.8068C122.086 64.682 121.994 64.5693 121.865 64.5612L121.486 64.5331C121.486 64.5331 121.45 64.5331 121.434 64.5411V64.4083C121.434 64.3157 121.47 64.2311 121.539 64.1667C121.599 64.1104 121.676 64.0822 121.756 64.0822C121.764 64.0822 121.776 64.0822 121.784 64.0822L123.137 64.1989C123.306 64.215 123.435 64.3519 123.435 64.525V65.3905C123.435 65.4831 123.399 65.5677 123.33 65.6321C123.262 65.6925 123.173 65.7247 123.081 65.7166L121.728 65.5959C121.559 65.5798 121.43 65.4429 121.43 65.2698L121.438 65.2657Z",
    fill: "white"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M126.092 50.3503C126.317 50.4509 126.49 50.5797 126.55 50.7408C126.55 50.7408 125.158 51.9163 122.883 51.8962C122.513 51.8962 121.74 50.8454 122.319 50.5234C122.416 50.471 122.529 50.4227 122.649 50.3784C122.899 50.1812 123.197 49.7021 123.177 48.5467C123.169 48.1723 123.133 47.7255 123.044 47.1941L126.253 46.5781C126.253 46.5781 125.17 48.744 126.092 50.3462V50.3503Z",
    fill: "#EBB376"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.045 47.2019C123.133 47.7333 123.169 48.1761 123.178 48.5545C125.347 48.5425 126.253 46.5859 126.253 46.5859L123.045 47.2019Z",
    fill: "black"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M111.873 123.137L107.666 122.348V125.339C107.666 125.339 105.512 128.91 104.582 129.151C103.652 129.397 103.85 130.351 103.85 130.351H108.495L109.623 129.002L109.868 130.351H110.762C110.762 130.351 111.704 127.633 110.762 125.725L111.877 123.133L111.873 123.137Z",
    fill: "#263238"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M126.716 122.766L122.509 123.092L122.88 125.342C122.88 125.342 120.726 128.913 119.796 129.155C118.866 129.4 119.063 130.354 119.063 130.354H123.709L124.836 129.006L125.082 130.354H125.976C125.976 130.354 126.918 127.637 125.976 125.729L126.716 122.766Z",
    fill: "#263238"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M124.148 38.1289C121.35 38.1289 120.452 39.6225 120.247 42.5049C119.989 46.104 120.786 48.6643 124.281 47.8954C129.027 46.8527 128.794 38.1289 124.148 38.1289Z",
    fill: "#EBB376"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M122.051 42.3516C122.051 42.3516 121.664 43.0802 121.237 43.511C121.237 43.511 121.475 43.8894 121.974 43.829L122.051 42.3516Z",
    fill: "#D58745"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M123.762 42.1225C123.758 42.352 123.874 42.5412 124.027 42.5452C124.18 42.5452 124.309 42.3641 124.313 42.1346C124.317 41.9052 124.201 41.7159 124.048 41.7119C123.895 41.7119 123.766 41.8931 123.762 42.1225Z",
    fill: "#263238"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M124.112 41.724L123.616 41.5146C123.616 41.5146 123.854 41.9414 124.112 41.724Z",
    fill: "#263238"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M120.908 42.0054C120.904 42.2348 121.02 42.424 121.173 42.4281C121.326 42.4281 121.455 42.2469 121.459 42.0174C121.463 41.788 121.346 41.5988 121.194 41.5947C121.041 41.5947 120.912 41.7759 120.908 42.0054Z",
    fill: "#263238"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M121.258 41.6107L120.762 41.4014C120.762 41.4014 121 41.8281 121.258 41.6107Z",
    fill: "#263238"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M125.006 40.7535C124.966 40.7535 124.925 40.7374 124.897 40.7012C124.527 40.2423 123.818 40.3268 123.81 40.3268C123.734 40.3349 123.665 40.2825 123.657 40.206C123.649 40.1295 123.702 40.0611 123.778 40.053C123.814 40.049 124.644 39.9484 125.115 40.5281C125.163 40.5885 125.155 40.673 125.094 40.7213C125.07 40.7415 125.038 40.7535 125.006 40.7535Z",
    fill: "#263238"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M120.645 40.4392C120.601 40.4392 120.557 40.4191 120.529 40.3788C120.484 40.3144 120.504 40.2298 120.569 40.1856C121.241 39.7387 121.785 39.9319 121.809 39.94C121.881 39.9682 121.918 40.0447 121.889 40.1171C121.861 40.1896 121.785 40.2258 121.712 40.1976C121.712 40.1976 121.269 40.0487 120.722 40.411C120.698 40.4271 120.674 40.4352 120.645 40.4352V40.4392Z",
    fill: "#263238"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2 42.8428C127.2 42.8428 125.895 40.5441 126.093 38.7727C126.093 38.7727 120.553 36.5062 120.275 42.1302C120.275 42.1302 119.736 37.1342 124.543 37.0296C129.341 36.9209 129.325 43.9539 126.842 46.0473C126.842 46.0473 128.005 44.284 127.2 42.8468V42.8428Z",
    fill: "#263238"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M126.745 43.4345C126.765 42.9836 127.228 42.2228 128.065 42.3153C128.931 42.412 129.345 44.1873 127.187 44.6141C126.877 44.6744 126.704 44.3725 126.745 43.4345Z",
    fill: "#EBB376"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M121.886 44.5451C122.055 44.9114 122.22 45.5958 122.22 45.5958C122.285 45.5958 122.349 45.5877 122.414 45.5797C123.291 45.5032 123.674 45.1811 123.831 44.843C123.915 44.6578 123.931 44.4686 123.927 44.3156C123.919 44.1385 123.875 44.0137 123.875 44.0137C123.432 44.3317 122.623 44.4646 122.184 44.5169C122.003 44.541 121.886 44.5451 121.886 44.5451Z",
    fill: "#263238"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M122.185 44.5169L122.294 44.8228C123.119 44.7504 123.691 44.5894 123.928 44.3156C123.92 44.1385 123.876 44.0137 123.876 44.0137C123.433 44.3317 122.624 44.4646 122.185 44.5169Z",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M122.413 45.5795C123.291 45.503 123.673 45.1809 123.83 44.8428C123.533 44.879 123.178 44.9555 122.872 45.1206C122.639 45.2413 122.502 45.4144 122.413 45.5795Z",
    fill: "#DE5753"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126.692 59.6461C127.324 60.1412 128.515 59.6944 129.389 59.1348C129.792 56.8804 129.953 55.1775 130.335 54.002C129.703 54.5978 125.536 58.7363 126.696 59.6461H126.692Z",
    fill: "black"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M122.111 57.6652H122.103C122.062 57.6652 122.03 57.633 122.022 57.5967C121.966 57.3874 120.681 52.4317 121.72 50.1612C121.74 50.1128 121.797 50.0967 121.845 50.1169C121.893 50.137 121.913 50.1934 121.889 50.2417C121.008 52.17 121.889 56.2602 122.143 57.3069C123.814 53.9494 127.348 50.4349 127.384 50.3987C127.421 50.3625 127.481 50.3625 127.517 50.3987C127.553 50.4349 127.553 50.4953 127.517 50.5315C127.481 50.5678 123.801 54.2232 122.199 57.6169C122.183 57.6491 122.151 57.6692 122.115 57.6692L122.111 57.6652Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M122.063 59.3074C121.547 59.3074 121.129 58.8887 121.129 58.3734C121.129 57.8581 121.547 57.4395 122.063 57.4395C122.578 57.4395 122.997 57.8581 122.997 58.3734C122.997 58.8887 122.578 59.3074 122.063 59.3074ZM122.063 57.8098C121.753 57.8098 121.499 58.0634 121.499 58.3734C121.499 58.6834 121.753 58.937 122.063 58.937C122.373 58.937 122.626 58.6834 122.626 58.3734C122.626 58.0634 122.373 57.8098 122.063 57.8098Z",
    fill: "#263238"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M122.32 54.8878L121.293 52.879C121.293 52.879 121.438 51.0472 121.293 50.9063C121.148 50.7614 119.091 49.8838 118.358 49.8838C117.626 49.8838 117.549 52.577 117.843 52.883C118.137 53.1889 120.001 53.8009 120.001 53.8009L121.869 55.1978L122.32 54.8878Z",
    fill: "#EBB376"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M131.735 51.4414C133.547 53.2409 128.132 60.3585 126.252 60.3585C124.372 60.3585 120 53.7965 120 53.7965L121.292 52.8786C121.292 52.8786 125.672 57.472 126.051 57.4841C126.429 57.4962 129.344 53.0396 129.879 52.5203C130.636 51.7836 131.739 51.4414 131.739 51.4414H131.735Z",
    fill: "#EBB376"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4112 51.8113L84.3017 50.5875C84.3017 50.5875 83.7824 49.7381 83.3476 49.412C82.9088 49.0859 81.1254 48.6189 81.1254 48.6189C80.4652 48.474 80.1149 48.6793 79.9297 49.0617L78.9273 51.3403C78.7623 51.7389 78.7743 51.9281 78.9273 51.9563C78.9273 51.9563 82.4056 52.8178 83.2671 52.065L85.4088 53.3089L86.4152 51.8113H86.4112Z",
    fill: "#EEC1BB"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5089 44.9072C98.5693 45.1649 98.521 45.4708 98.3318 45.8211C97.7964 46.8114 95.6385 51.0183 94.5959 52.371C92.901 54.561 91.5323 55.7325 90.4856 55.805C88.7424 55.9298 83.6096 53.6472 83.6096 53.6472L85.6466 50.6037C85.6466 50.6037 88.6901 52.0046 89.9824 51.7108C91.2706 51.4088 93.7464 44.6616 94.6281 42.9668C94.6281 42.9668 98.1627 43.3372 98.5129 44.9072H98.5089Z",
    fill: "#28BFB2"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.9699 54.2591C92.9699 54.2591 92.6801 54.7261 91.8226 55.2454C92.5633 53.623 93.6905 47.4395 93.6905 47.4395L92.9699 54.2551V54.2591Z",
    fill: "black"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M106.987 127.294H110.473C110.59 127.294 110.691 127.379 110.719 127.491L111.286 130.044C111.335 130.273 111.19 130.499 110.96 130.547C110.928 130.555 110.9 130.555 110.868 130.555C109.741 130.535 108.919 130.466 107.502 130.466C106.629 130.466 104 130.559 102.796 130.559C101.592 130.559 101.435 129.367 101.927 129.259C104.137 128.776 105.803 128.107 106.508 127.475C106.641 127.355 106.81 127.29 106.991 127.294H106.987Z",
    fill: "#28BFB2"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M106.987 127.294H110.473C110.59 127.294 110.691 127.379 110.719 127.491L111.286 130.044C111.335 130.273 111.19 130.499 110.96 130.547C110.928 130.555 110.9 130.555 110.868 130.555C109.741 130.535 108.919 130.466 107.502 130.466C106.629 130.466 104 130.559 102.796 130.559C101.592 130.559 101.435 129.367 101.927 129.259C104.137 128.776 105.803 128.107 106.508 127.475C106.641 127.355 106.81 127.29 106.991 127.294H106.987Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2081 127.201H95.6945C95.8112 127.201 95.9118 127.286 95.94 127.399L96.5077 129.951C96.556 130.18 96.411 130.406 96.1816 130.454C96.1494 130.462 96.1212 130.462 96.089 130.462C94.9618 130.442 94.1405 130.374 92.7234 130.374C91.8498 130.374 89.221 130.466 88.0173 130.466C86.8136 130.466 86.6566 129.275 87.1477 129.166C89.3579 128.683 91.0205 128.015 91.7291 127.383C91.8619 127.262 92.031 127.197 92.2122 127.201H92.2081Z",
    fill: "#28BFB2"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M92.2081 127.201H95.6945C95.8112 127.201 95.9118 127.286 95.94 127.399L96.5077 129.951C96.556 130.18 96.411 130.406 96.1816 130.454C96.1494 130.462 96.1212 130.462 96.089 130.462C94.9618 130.442 94.1405 130.374 92.7234 130.374C91.8498 130.374 89.221 130.466 88.0173 130.466C86.8136 130.466 86.6566 129.275 87.1477 129.166C89.3579 128.683 91.0205 128.015 91.7291 127.383C91.8619 127.262 92.031 127.197 92.2122 127.201H92.2081Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M108.835 62.7013H93.6093C92.16 70.6039 87.6311 102.705 90.8798 127.625H96.0328C96.0328 127.625 95.5538 89.7746 100.107 77.5403C100.63 84.0862 105.952 127.597 105.952 127.597H111.198C111.198 127.597 110.413 111.228 109.628 95.7689C109.133 86.0346 108.851 64.6981 108.831 62.6973L108.835 62.7013Z",
    fill: "#263238"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.835 62.7013H93.6093C92.16 70.6039 87.6311 102.705 90.8798 127.625H96.0328C96.0328 127.625 95.5538 89.7746 100.107 77.5403C100.63 84.0862 105.952 127.597 105.952 127.597H111.198C111.198 127.597 110.413 111.228 109.628 95.7689C109.133 86.0346 108.851 64.6981 108.831 62.6973L108.835 62.7013Z",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.107 77.5447C99.4347 79.3482 98.8752 81.5986 98.4082 84.1308C97.9814 78.3055 99.6843 72.126 99.6843 72.126L100.107 77.5447Z",
    fill: "black"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5825 64.5445L93.2878 64.5163L93.4811 62.8818H95.5825V64.5445Z",
    fill: "black"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M103.884 62.8818H108.807V64.7055L103.884 64.6451V62.8818Z",
    fill: "black"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M103.336 64.6411L96.1301 64.5525V62.8818H103.336V64.6411Z",
    fill: "black"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9017 64.7459H98.2028C97.9612 64.7459 97.764 64.5487 97.764 64.3071V63.2162C97.764 62.9746 97.9612 62.7773 98.2028 62.7773H99.9017C100.143 62.7773 100.34 62.9746 100.34 63.2162V64.3071C100.34 64.5487 100.143 64.7459 99.9017 64.7459ZM98.2028 63.1759C98.1827 63.1759 98.1666 63.192 98.1666 63.2121V64.3031C98.1666 64.3232 98.1827 64.3393 98.2028 64.3393H99.9017C99.9218 64.3393 99.9379 64.3232 99.9379 64.3031V63.2121C99.9379 63.192 99.9218 63.1759 99.9017 63.1759H98.2028Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M100.107 63.9162H99.2211C99.1084 63.9162 99.0198 63.8277 99.0198 63.715C99.0198 63.6022 99.1084 63.5137 99.2211 63.5137H100.107C100.22 63.5137 100.308 63.6022 100.308 63.715C100.308 63.8277 100.22 63.9162 100.107 63.9162Z",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M111.211 44.1864C111.033 44.8184 110.836 45.6437 110.643 46.6461C110.418 47.7895 110.192 49.1542 109.999 50.7001C109.604 53.8321 109.347 58.6993 109.459 62.8861L92.9981 62.7452C92.9981 62.7452 92.3217 52.0688 94.6245 42.9746L110.124 42.7814C110.868 42.7693 111.416 43.4738 111.211 44.1904V44.1864Z",
    fill: "#28BFB2"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.644 46.6462C110.418 47.7895 110.016 50.7887 109.818 52.3346C108.297 51.5979 108.188 47.6124 108.188 47.6124C108.856 47.5157 110.321 46.3483 110.644 46.6462Z",
    fill: "black"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M100.86 44.3996C100.86 44.3996 104.117 44.4318 105.273 43.0791C104.536 42.4551 104.218 41.2152 104.121 39.8827C104.053 38.9205 104.093 37.9101 104.174 37.0485C104.202 36.7466 104.234 36.4608 104.27 36.2031L100.687 39.6331C100.707 39.6935 100.723 39.7539 100.744 39.8183C100.796 39.9994 100.848 40.1846 100.885 40.3698C100.981 40.8368 101.017 41.3038 100.937 41.7305C100.852 42.125 100.889 42.4068 100.748 42.6323C100.635 42.8215 100.393 42.9745 99.866 43.1315C99.5238 43.8118 100.864 44.3996 100.864 44.3996H100.86Z",
    fill: "#EEC1BB"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.743 42.6365C101.85 42.2178 103.206 40.5511 104.048 39.0495C103.979 38.0874 104.092 37.9142 104.173 37.0527L100.743 39.8265C100.795 40.0076 100.847 40.1928 100.883 40.378C100.98 40.845 101.016 41.312 100.936 41.7387C100.851 42.1332 100.888 42.4151 100.747 42.6405L100.743 42.6365Z",
    fill: "black"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1565 30.4181C97.1565 30.4181 96.1219 34.2224 98.0099 35.9495C99.894 37.6765 100.723 30.4624 100.723 30.4624L97.1605 30.4141L97.1565 30.4181Z",
    fill: "#263238"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M103.622 39.7134C102.459 41.0338 100.788 41.223 99.4272 40.6111C98.5536 40.2206 97.8048 39.496 97.4022 38.5338C97.3458 38.409 97.3016 38.2762 97.2573 38.1393C96.5165 35.6554 96.6695 31.4767 99.3507 30.2126C101.255 29.2987 103.55 30.0999 104.463 32.0081C104.729 32.5475 104.854 33.1474 104.842 33.7512C104.83 36.5532 104.959 38.2037 103.618 39.7094L103.622 39.7134Z",
    fill: "#EEC1BB"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M100.643 34.7738C100.672 34.9993 100.547 35.1925 100.398 35.2005C100.245 35.2086 100.12 35.0274 100.104 34.802C100.092 34.5766 100.205 34.3833 100.354 34.3753C100.503 34.3672 100.631 34.5443 100.647 34.7738H100.643Z",
    fill: "#263238"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M98.067 34.9154C98.0952 35.1408 97.9663 35.3341 97.8174 35.3421C97.6684 35.3502 97.5396 35.169 97.5235 34.9436C97.5114 34.7181 97.6241 34.5249 97.7731 34.5168C97.922 34.5088 98.0549 34.698 98.067 34.9154Z",
    fill: "#263238"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8915 34.9795C98.658 35.6921 98.3279 36.3684 97.9092 36.9883C98.2393 37.1977 98.6419 37.25 99.0163 37.1333L98.8915 34.9795Z",
    fill: "#D4827D"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0686 33.9084C97.1169 33.9285 97.1693 33.9205 97.2055 33.8883C97.4632 33.6669 97.8134 33.5823 98.1435 33.6548C98.2119 33.6789 98.2884 33.6387 98.3126 33.5702C98.3367 33.5018 98.2965 33.4253 98.228 33.4012C97.8094 33.2965 97.3665 33.4012 97.0404 33.6789C96.9801 33.7232 96.972 33.8078 97.0163 33.8641C97.0163 33.8641 97.0485 33.8963 97.0686 33.9044V33.9084Z",
    fill: "#263238"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M101.094 33.7188C101.123 33.7188 101.147 33.7067 101.167 33.6906C101.211 33.6343 101.203 33.5497 101.147 33.5054C100.813 33.2317 100.366 33.1351 99.947 33.2518C99.8786 33.276 99.8423 33.3524 99.8625 33.4209C99.8866 33.4893 99.9631 33.5256 100.032 33.5054C100.362 33.4249 100.712 33.5054 100.978 33.7188C101.014 33.7349 101.054 33.7389 101.09 33.7188H101.094Z",
    fill: "#263238"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M102.604 30.3781L102.362 30.9095C103.292 31.2033 103.115 32.2822 102.93 32.7694C102.539 33.812 103.139 35.4183 103.94 36.0544C103.94 36.0544 103.96 35.6035 104.343 35.7082C104.725 35.8128 104.637 38.1558 103.904 39.279C103.904 39.279 105.019 38.2605 105.631 35.7927C106.199 33.5141 106.259 31.614 105.784 30.7404L102.6 30.374L102.604 30.3781Z",
    fill: "#263238"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M106.195 35.9818C105.921 36.634 105.398 37.1452 104.742 37.4109C103.872 37.7572 103.341 37.0043 103.498 36.1308C103.643 35.3578 104.267 34.2185 105.181 34.2547C106.094 34.291 106.525 35.1807 106.195 35.9818Z",
    fill: "#EEC1BB"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0931 37.9178C99.3306 38.2922 99.6164 39.0128 99.6164 39.0128C99.6849 39.0007 99.7573 38.9846 99.8258 38.9685C100.772 38.7551 101.138 38.3405 101.259 37.95C101.323 37.7366 101.311 37.5233 101.283 37.3582C101.251 37.165 101.182 37.0361 101.182 37.0361C100.748 37.4508 99.8821 37.7165 99.4151 37.8413C99.2179 37.8936 99.0931 37.9178 99.0931 37.9178Z",
    fill: "#263238"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4152 37.8374L99.5763 38.1554C100.466 37.9501 101.066 37.6884 101.283 37.3543C101.251 37.1611 101.183 37.0322 101.183 37.0322C100.748 37.4469 99.8822 37.7126 99.4152 37.8374Z",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8296 38.9687C100.776 38.7554 101.142 38.3407 101.263 37.9502C100.945 38.0347 100.566 38.1756 100.26 38.3971C100.023 38.5661 99.898 38.7715 99.8296 38.9687Z",
    fill: "#DE5753"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1571 30.4184C97.3825 29.1462 97.9502 28.0915 98.6345 26.8516L98.8318 28.2968C99.1257 27.7292 99.6047 27.3226 100.116 26.9401L100.374 28.4941C100.676 27.8218 101.352 27.4393 102.234 27.2099L102.101 28.5504C102.523 27.9546 103.071 27.544 103.783 27.3588L103.715 28.6309C104.009 28.2324 104.158 28.164 104.661 28.0714L105.788 30.7485L103.039 31.6342L97.6925 31.8153L97.1571 30.4224V30.4184Z",
    fill: "#263238"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M112.969 62.6484L112.828 65.1203C112.828 65.1203 113.259 66.0341 113.291 66.5897C113.323 67.1452 112.144 70.7845 112.144 70.7845L109.209 69.2789C109.209 69.2789 109.873 65.4826 110.996 65.1766L111.137 62.6645L112.969 62.6484Z",
    fill: "#EEC1BB"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M111.202 43.5508C113.339 48.0435 115.69 52.3833 115.119 55.1329L113.577 64.7464L110.61 64.6257L111.608 55.8052C112.534 54.1748 109.893 50.6442 108.186 47.6128L111.202 43.5508Z",
    fill: "#28BFB2"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 55.0527L117.739 58.6598L116.519 59.7709L110.851 57.4118L111.375 55.0527Z",
    fill: "#EBB376"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M115.07 58.0439L116.519 59.775C116.519 59.775 116.785 61.5906 116.958 61.6993C117.131 61.808 119.333 62.2066 120.046 62.0455C120.763 61.8845 120.235 59.2396 119.881 59.0101C119.527 58.7766 117.574 58.5955 117.574 58.5955L115.441 57.6494L115.07 58.052V58.0439Z",
    fill: "#EBB376"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.1898 87.6812C78.6198 84.1184 77.1383 81.0427 77.1383 81.0427C77.1383 81.0427 77.0457 80.2295 77.3235 79.1586C77.7381 78.905 78.0562 78.8486 78.0562 78.8486C78.0562 78.8486 79.9644 81.8438 80.1938 87.6812H80.1898Z",
    fill: "black"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1586 127.673L93.9903 127.174C93.318 117.943 91.5064 106.8 89.9686 98.4463C89.7271 97.1379 89.4936 95.8979 89.2681 94.7466C89.1594 94.1991 89.0588 93.6717 88.9581 93.1644C88.467 90.6604 88.0564 88.6838 87.7987 87.4599C87.6095 86.5662 87.5048 86.0791 87.5048 86.0791L80.9227 87.9873L81.4702 89.6459L83.2778 95.121L83.4831 95.749L84.6828 99.3641L86.7158 105.52C86.9976 114.936 92.1546 127.673 92.1546 127.673H92.1586Z",
    fill: "#EBB376"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1921 127.227L78.0842 127.046C79.0705 117.034 79.1107 104.566 78.9779 95.9024C78.9537 94.5618 78.9296 93.3058 78.9054 92.1705C78.9054 92.1101 78.9014 92.0578 78.9014 92.0015C78.845 89.747 78.7887 87.9556 78.7484 86.8163C78.7122 85.9266 78.6921 85.4395 78.6921 85.4395L71.8805 86.2003L72.3032 89.0345L72.9231 93.2011L73.0439 94.0184L73.4706 96.8565L74.6099 104.465C73.2855 113.793 76.2001 127.223 76.2001 127.223L76.1921 127.227Z",
    fill: "#EBB376"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.9155 93.2043L78.9018 92.1697C78.9018 92.1093 78.8978 92.057 78.8978 92.0006C78.8414 89.7462 78.785 87.9547 78.7448 86.8154L72.2995 89.0336L72.9195 93.2003L72.9155 93.2043Z",
    fill: "black"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.4628 90.6604L82.1625 91.7313L81.4741 89.6459L87.8026 87.46C87.9676 88.2369 88.1931 89.3239 88.4628 90.6604Z",
    fill: "black"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1099 70.1736C72.1099 70.1736 68.0519 77.7662 71.8723 91.6027L79.316 90.7533V83.6196L80.9263 90.4956L88.3901 88.998C86.0954 77.7702 83.1445 72.7339 83.1445 72.7339L82.7661 69.3604L72.1179 70.1776L72.1099 70.1736Z",
    fill: "#28BFB2"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.1099 70.1736C72.1099 70.1736 68.0519 77.7662 71.8723 91.6027L79.316 90.7533V83.6196L80.9263 90.4956L88.3901 88.998C86.0954 77.7702 83.1445 72.7339 83.1445 72.7339L82.7661 69.3604L72.1179 70.1776L72.1099 70.1736Z",
    fill: "white"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2943 126.844C75.2983 126.606 78.221 126.791 78.221 126.791C78.221 126.791 80.0165 128.619 81.7597 129.03C83.5028 129.44 82.5286 130.487 80.5801 130.487H75.7572C74.3724 130.487 75.2379 129.308 75.2943 126.844Z",
    fill: "#263238"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7551 127.54C79.3485 127.54 78.7003 127.242 78.5433 127.17C78.5312 127.166 78.5232 127.158 78.5191 127.15C78.5191 127.15 78.5111 127.138 78.5071 127.134C78.499 127.117 78.495 127.093 78.5071 127.073C78.5192 127.045 78.7607 126.365 79.1593 126.2C79.284 126.147 79.4129 126.151 79.5377 126.212C79.6705 126.276 79.7349 126.357 79.7309 126.457C79.7229 126.61 79.5135 126.763 79.276 126.892C79.5216 126.868 79.7752 126.876 79.9322 126.964C80.0127 127.013 80.065 127.077 80.0892 127.162C80.1335 127.335 80.0731 127.427 80.0167 127.472C79.9563 127.52 79.8678 127.54 79.7591 127.54H79.7551ZM78.813 127.121C79.2438 127.303 79.7792 127.464 79.9161 127.351C79.9282 127.343 79.9644 127.311 79.9362 127.198C79.9241 127.154 79.9 127.121 79.8517 127.097C79.6423 126.976 79.1391 127.049 78.813 127.125V127.121ZM79.3364 126.316C79.2961 126.316 79.2599 126.324 79.2196 126.34C79.0022 126.429 78.8211 126.747 78.7204 126.968C79.1512 126.803 79.5699 126.578 79.5779 126.445C79.5779 126.405 79.5135 126.365 79.4733 126.348C79.429 126.328 79.3847 126.316 79.3404 126.316H79.3364Z",
    fill: "#28BFB2"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6386 126.844C91.6426 126.606 94.5653 126.791 94.5653 126.791C94.5653 126.791 96.3608 128.619 98.104 129.03C99.8471 129.44 98.8729 130.487 96.9244 130.487H92.1016C90.7167 130.487 91.5822 129.308 91.6386 126.844Z",
    fill: "#263238"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0994 127.54C95.6928 127.54 95.0447 127.242 94.8876 127.17C94.8756 127.166 94.8675 127.158 94.8635 127.15C94.8635 127.15 94.8554 127.138 94.8514 127.134C94.8434 127.117 94.8393 127.093 94.8514 127.073C94.8635 127.045 95.105 126.365 95.5036 126.2C95.6284 126.147 95.7572 126.151 95.882 126.212C96.0149 126.276 96.0793 126.357 96.0752 126.457C96.0672 126.61 95.8578 126.763 95.6203 126.892C95.8659 126.868 96.1195 126.876 96.2765 126.964C96.357 127.013 96.4094 127.077 96.4335 127.162C96.4778 127.335 96.4174 127.427 96.3611 127.472C96.3007 127.52 96.2081 127.54 96.1034 127.54H96.0994ZM95.1574 127.121C95.5881 127.303 96.1235 127.464 96.2604 127.351C96.2725 127.343 96.3087 127.311 96.2806 127.198C96.2685 127.154 96.2443 127.121 96.196 127.097C95.9867 126.976 95.4835 127.049 95.1574 127.125V127.121ZM95.6807 126.316C95.6405 126.316 95.6042 126.324 95.564 126.34C95.3466 126.429 95.1654 126.747 95.0648 126.968C95.4955 126.803 95.9142 126.578 95.9223 126.445C95.9223 126.405 95.8579 126.365 95.8176 126.348C95.7733 126.328 95.729 126.316 95.6847 126.316H95.6807Z",
    fill: "#28BFB2"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.3167 83.6198C80.5889 80.9909 81.4746 78.8291 81.4746 78.8291C81.4746 78.8291 81.7564 85.4797 80.927 90.4958L79.3167 83.6198Z",
    fill: "black"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7438 37.6129C76.7438 37.6129 73.6883 36.0791 71.305 37.4197C70.206 38.0356 69.8719 39.505 69.6867 40.6483C69.425 42.2465 69.4411 43.873 69.2801 45.4792C69.2116 46.1596 69.0748 46.8238 68.7889 47.4478C68.4105 48.2771 67.8066 50.1089 67.8066 50.1089L69.6464 50.4792L70.2583 49.6701L70.3831 50.6282L75.5482 51.6709L75.9105 50.8496L76.2728 51.8198L77.7181 51.5903L78.2293 50.439L78.487 51.4696L80.5925 51.1354L81.0112 49.8794L81.5063 50.9905L83.0562 50.7449L83.02 47.009C83.02 47.009 82.7986 44.5734 82.5973 43.3214C82.4202 42.2264 82.1585 41.1234 81.6835 40.1169C80.7334 38.104 78.954 37.0936 76.7398 37.6209L76.7438 37.6129Z",
    fill: "#263238"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0743 51.877C83.6725 52.195 89.6669 57.7505 89.071 60.3391C88.4752 62.9277 83.592 66.3294 83.592 66.3294C83.592 66.3294 86.1805 66.9695 86.1846 67.3037C86.1886 67.6338 84.6507 69.3931 84.4253 69.4534C84.3247 69.4816 82.5976 68.5919 82.1709 68.3061C81.8247 68.0726 81.716 66.736 81.716 66.736C82.9116 65.0895 86.3053 60.9873 86.3818 60.2505C86.4583 59.5138 81.7039 55.8464 81.7039 55.8464C81.7039 55.8464 81.092 53.9583 81.2892 52.9921C81.4825 52.046 82.0823 51.885 82.0823 51.885L82.0743 51.877Z",
    fill: "#EBB376"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M81.688 56.0151C81.1244 53.9862 80.7983 52.09 81.9376 51.7076C83.1293 51.3292 89.2363 57.3114 89.1156 60.0691C89.023 62.1222 84.3732 66.0111 84.3732 66.0111L83.0648 64.6625C83.0648 64.6625 86.1123 60.5522 86.1888 60.0691C86.2653 59.59 81.688 56.0151 81.688 56.0151Z",
    fill: "#28BFB2"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.688 56.0151C81.1244 53.9862 80.7983 52.09 81.9376 51.7076C83.1293 51.3292 89.2363 57.3114 89.1156 60.0691C89.023 62.1222 84.3732 66.0111 84.3732 66.0111L83.0648 64.6625C83.0648 64.6625 86.0842 60.5643 86.1888 60.0691C86.2935 59.5739 81.688 56.0151 81.688 56.0151Z",
    fill: "black"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.091 57.9391L82.5773 56.7153L82.8591 54.8594L84.091 57.9391Z",
    fill: "black"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1103 68.6158V70.1737L82.7625 69.3565V67.5127L72.1103 68.6158Z",
    fill: "#263238"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2425 67.8889L77.9129 68.0977L78.071 69.8619L80.4006 69.6532L80.2425 67.8889Z",
    fill: "white"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M75.619 67.9653L75.0923 67.9922L75.2295 70.6819L75.7562 70.6551L75.619 67.9653Z",
    fill: "#28BFB2"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.619 67.9653L75.0923 67.9922L75.2295 70.6819L75.7562 70.6551L75.619 67.9653Z",
    fill: "white"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1241 67.2524L81.5974 67.2793L81.7346 69.969L82.2613 69.9422L82.1241 67.2524Z",
    fill: "#28BFB2"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M82.1241 67.2524L81.5974 67.2793L81.7346 69.969L82.2613 69.9422L82.1241 67.2524Z",
    fill: "white"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7462 67.7009L72.094 68.6228C71.8404 64.6614 72.4845 62.2057 70.1375 55.1485C69.9362 54.5326 69.7832 53.2765 69.5457 52.5841C70.9869 52.254 71.5022 52.2741 72.9998 52.0245C74.5819 51.7427 76.1802 51.5736 77.7824 51.5213C79.8557 51.5052 82.2349 51.7387 82.2349 51.7387C82.2349 51.7387 82.5731 51.8192 82.7865 54.0133C82.9837 56.0785 83.1729 60.2009 82.7462 67.7049V67.7009Z",
    fill: "#28BFB2"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.7455 67.7011L72.0974 68.623C71.9525 66.3847 72.198 64.7099 71.8075 62.1173C71.5539 60.4386 71.2801 58.6552 70.4347 56.0586C70.3421 55.7566 70.2093 55.338 70.1046 55.0199C69.9033 54.4 69.7906 53.2768 69.5491 52.5803C71.0225 52.2462 71.5056 52.2703 73.0032 52.0167C74.5813 51.7389 76.1835 51.5658 77.7858 51.5135C79.8631 51.4974 82.2383 51.7349 82.2383 51.7349C82.2383 51.7349 82.5805 51.8154 82.7938 54.0095C82.9871 56.0707 83.1803 60.1971 82.7496 67.7011H82.7455Z",
    fill: "black"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M76.905 53.869C74.2802 53.5349 73.4911 52.4117 73.4911 52.4117C75.1578 50.8417 73.7729 48.1162 73.7729 48.1162L76.9332 48.708C76.8486 49.2313 76.8164 49.6702 76.8083 50.0365C76.7842 51.9528 77.6538 51.9729 77.6538 51.9729C78.2093 53.0115 76.905 53.869 76.905 53.869Z",
    fill: "#EBB376"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.9328 48.7041C76.8483 49.2274 76.8684 49.3563 76.8684 49.3563L76.8161 49.8675L73.7766 48.1123L76.9369 48.7041H76.9328Z",
    fill: "black"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0438 47.2109C80.0196 47.3075 79.9915 47.4001 79.9633 47.4887C79.5848 48.636 78.7757 49.3446 77.3546 49.3768C77.1573 49.3848 76.952 49.3768 76.7306 49.3526C76.6018 49.3365 76.4609 49.3204 76.32 49.2963C71.4568 48.5032 71.2193 39.6626 75.9214 39.4049C78.7475 39.2479 79.7419 40.7173 80.1082 43.6199C80.2813 45.0008 80.2934 46.2407 80.0438 47.2109Z",
    fill: "#EBB376"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2685 43.5635C78.2685 43.5635 78.6992 44.2801 79.1542 44.6907C79.1542 44.6907 78.9327 45.0892 78.4255 45.053L78.2645 43.5635H78.2685Z",
    fill: "#D58745"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0831 44.3446C73.0831 44.3446 74.2787 41.9493 73.9808 40.1658C73.9808 40.1658 79.4639 37.5692 80.0517 43.2456C80.0517 43.2456 80.3214 38.161 75.4542 38.318C70.5911 38.471 70.9937 45.5845 73.6225 47.5692C73.6225 47.5692 72.3464 45.8502 73.0871 44.3526L73.0831 44.3446Z",
    fill: "#263238"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M73.578 44.9162C73.5337 44.4613 73.0224 43.7166 72.181 43.8534C71.3115 43.9984 70.9894 45.818 73.1955 46.132C73.5135 46.1763 73.6706 45.8623 73.582 44.9122L73.578 44.9162Z",
    fill: "#EBB376"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6427 43.4181C76.6427 43.6355 76.5219 43.8127 76.377 43.8086C76.232 43.8046 76.1153 43.6315 76.1193 43.4101C76.1193 43.1927 76.2401 43.0156 76.385 43.0196C76.5299 43.0196 76.6467 43.1967 76.6427 43.4181Z",
    fill: "#263238"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M76.324 43.0278L76.799 42.8467C76.799 42.8467 76.5575 43.2412 76.324 43.0278Z",
    fill: "#263238"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3504 43.3986C79.3504 43.616 79.2296 43.7931 79.0847 43.7891C78.9397 43.7891 78.823 43.608 78.827 43.3906C78.827 43.1732 78.9478 42.996 79.0927 43.0001C79.2376 43.0001 79.3544 43.1772 79.3504 43.3986Z",
    fill: "#263238"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0324 43.0122L79.5075 42.8311C79.5075 42.8311 79.2659 43.2256 79.0324 43.0122Z",
    fill: "#263238"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5265 42.078C75.4903 42.078 75.4541 42.0699 75.4259 42.0458C75.3695 41.9975 75.3655 41.9129 75.4138 41.8606C75.8768 41.3292 76.6658 41.45 76.698 41.454C76.7705 41.4661 76.8188 41.5345 76.8067 41.607C76.7946 41.6794 76.7262 41.7277 76.6538 41.7157C76.6457 41.7157 75.9774 41.615 75.6111 42.0337C75.5869 42.0619 75.5587 42.0739 75.5225 42.078H75.5265Z",
    fill: "#263238"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6689 41.9209C79.6367 41.9209 79.6045 41.9168 79.5804 41.8967C79.0731 41.5344 78.6665 41.6552 78.6504 41.6632C78.582 41.6834 78.5055 41.6471 78.4854 41.5787C78.4612 41.5102 78.5015 41.4338 78.5699 41.4136C78.59 41.4056 79.1134 41.2405 79.7374 41.6834C79.7978 41.7236 79.8098 41.8082 79.7696 41.8685C79.7454 41.9007 79.7132 41.9209 79.677 41.9249L79.6689 41.9209Z",
    fill: "#263238"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3562 46.2891C78.4206 46.2891 78.485 46.2891 78.5535 46.281C78.5977 46.281 78.6299 46.2408 78.6259 46.1965C78.6259 46.1522 78.5857 46.12 78.5414 46.124C77.3014 46.2126 76.7741 45.3913 76.7499 45.3551C76.7258 45.3189 76.6774 45.3068 76.6412 45.3309C76.605 45.3551 76.5929 45.4034 76.6171 45.4396C76.6412 45.4759 77.1605 46.2891 78.3562 46.2891Z",
    fill: "#263238"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8665 37.923C74.8665 37.923 76.8954 37.8223 78.4373 38.6597C79.9792 39.497 80.0516 40.7813 80.0516 40.7813L79.5122 40.58L78.4333 39.7185C78.4333 39.7185 78.6305 40.0123 78.6507 40.6001C78.6507 40.6001 78.3125 39.8795 77.8455 39.7627C77.8455 39.7627 78.0629 40.3787 77.5919 40.7813C77.5919 40.7813 77.4027 40.0848 76.9679 39.8634C76.9679 39.8634 77.0484 40.266 76.2433 40.7813C76.2433 40.7813 76.2835 40.0848 75.7843 39.7909C75.7843 39.7909 75.3979 40.5236 74.8665 40.6323C74.8665 40.6323 75.261 40.266 75.1845 40.0445C75.1845 40.0445 74.488 40.7048 73.6064 40.7772C72.7247 40.8497 71.5492 38.9817 74.8705 37.9189L74.8665 37.923Z",
    fill: "#263238"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.8307 45.7969C72.9837 45.8372 73.3299 46.0425 73.3299 46.0425C73.8331 46.3484 74.7027 47.6608 74.7027 47.6608C74.7027 47.6608 75.4435 48.6471 75.2583 49.1785C75.1496 49.4885 74.896 49.9515 74.896 49.9515L74.8597 52.5803L73.6238 52.2784L73.7728 49.3798L72.7623 46.0465C72.6536 46.0223 72.4885 45.9579 72.2832 45.8613C72.2832 45.8613 72.553 45.7285 72.8307 45.8009V45.7969Z",
    fill: "black"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7586 50.9905V49.7747C74.7586 49.7747 75.2417 49.5815 75.1692 49.0702C75.0968 48.559 73.1725 46.1153 72.9913 46.0469C72.8101 45.9784 71.2441 46.4454 71.1998 46.4535C71.1555 46.4615 72.0211 48.8931 73.6596 49.7707L73.7602 51.2522L74.7546 50.9865L74.7586 50.9905Z",
    fill: "#EBB376"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6488 51.9727H80.2816L78.1399 55.463L71.6383 52.9348L73.4902 52.4115L77.6488 51.9727Z",
    fill: "#EBB376"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.027 61.3404C75.4593 61.9643 72.6131 60.354 71.2605 59.0416C70.9102 57.4877 71.1035 58.313 70.3064 55.6479L71.7395 54.5891L72.7178 55.2695L72.8788 53.4136L73.2492 53.5585L73.3539 52.4474L72.9553 52.5602L73.0036 52.0167L73.4022 51.9482L75.1936 53.3613L75.254 54.3395L75.6405 54.4885C75.6405 54.4885 76.7838 60.5151 76.027 61.3404Z",
    fill: "black"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5455 52.581C70.3145 52.3475 72.9876 56.3129 72.9876 56.3129L73.5834 49.9521L74.936 50.2823C74.936 50.2823 75.8781 59.8354 74.936 60.2541C73.994 60.6728 71.5705 59.3161 69.2235 55.8781C68.37 54.6301 68.6357 52.8547 69.5455 52.581Z",
    fill: "#28BFB2"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M69.5455 52.581C70.3145 52.3475 72.9876 56.3129 72.9876 56.3129L73.5834 49.9521L74.936 50.2823C74.936 50.2823 75.8781 59.8354 74.936 60.2541C73.994 60.6728 71.5705 59.3161 69.2235 55.8781C68.37 54.6301 68.6357 52.8547 69.5455 52.581Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWelcome);
export default __webpack_public_path__ + "static/media/illustration-welcome.1e5f70014c27086f86963af11552fdcc.svg";
export { ForwardRef as ReactComponent };